﻿@file:OptIn(ExperimentalMaterial3Api::class, ExperimentalFoundationApi::class)

package com.example.monetix.ui.screens

import androidx.compose.animation.AnimatedVisibility
import androidx.compose.animation.animateContentSize
import androidx.compose.animation.expandVertically
import androidx.compose.animation.fadeIn
import androidx.compose.animation.fadeOut
import androidx.compose.animation.shrinkVertically
import androidx.compose.animation.core.*
import androidx.compose.ui.graphics.Brush
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.foundation.BorderStroke
import androidx.compose.foundation.ExperimentalFoundationApi
import androidx.compose.foundation.background
import androidx.compose.foundation.clickable
import androidx.compose.foundation.combinedClickable
import androidx.compose.foundation.horizontalScroll
import androidx.compose.foundation.interaction.MutableInteractionSource
import androidx.compose.foundation.layout.*
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.foundation.lazy.items
import androidx.compose.foundation.lazy.rememberLazyListState
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.foundation.text.KeyboardOptions
import androidx.compose.foundation.verticalScroll
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.filled.*
import androidx.compose.material.icons.outlined.*
import androidx.compose.material.icons.rounded.*
import androidx.compose.material3.*
import com.example.monetix.ui.components.MonetixTextField as OutlinedTextField
import androidx.compose.runtime.*
import androidx.compose.runtime.saveable.rememberSaveable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.draw.blur
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.hapticfeedback.HapticFeedbackType
import androidx.compose.ui.platform.LocalHapticFeedback
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextOverflow
import androidx.compose.ui.text.input.KeyboardType
import androidx.compose.ui.text.input.PasswordVisualTransformation
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import androidx.compose.ui.zIndex
import com.example.monetix.db.*
import com.example.monetix.ui.components.ModernMoneyText
import com.example.monetix.ui.components.TxLogo
import com.example.monetix.utils.formatEuroFromCents
import com.example.monetix.utils.MonthlyStats
import com.example.monetix.utils.BankNotificationCatcher
import dev.gitlive.firebase.Firebase
import dev.gitlive.firebase.auth.auth
import kotlinx.coroutines.launch
import kotlinx.coroutines.Dispatchers
import kotlinx.datetime.Clock
import kotlinx.datetime.LocalDate
import kotlinx.datetime.TimeZone
import kotlinx.datetime.todayIn
import kotlinx.datetime.DayOfWeek
import androidx.compose.ui.platform.LocalClipboardManager
import androidx.compose.ui.text.AnnotatedString
import com.example.monetix.ui.dialogs.CalculatorDialog
import kotlinx.datetime.toLocalDateTime
import com.example.monetix.stripSystemMarker
import com.example.monetix.ui.components.MonetixGlassSwitch
import com.example.monetix.ui.theme.getDynamicBalanceColor
import com.example.monetix.utils.shareText
import com.example.monetix.utils.triggerHapticTick
import com.russhwolf.settings.Settings
import kotlin.math.abs
import kotlin.random.Random

private val mesiShort = listOf("Gen", "Feb", "Mar", "Apr", "Mag", "Giu", "Lug", "Ago", "Set", "Ott", "Nov", "Dic")

// ðŸš€ PUBBLICO E VISIBILE COSàŒ FINANCING SCREEN NON DA ERRORE
val FinancingEntity.smartDueDay: Int
    get() {
        val match = Regex("\\[DAY:(\\d+)\\]").find(this.purpose ?: "")
        return match?.groupValues?.get(1)?.toIntOrNull()
            ?: try { LocalDate.fromEpochDays(this.startEpochDay.toInt()).dayOfMonth } catch(e: Exception) { 1 }
    }

private var isSavingsPopupDismissedInSession = false
private var hasSeenMorningGreetingInSession = false

// ðŸš€ FUNZIONE ISOLATA
private fun getShiftedDueDate(baseDay: Int, targetMonth: Int, targetYear: Int): LocalDate {
    var d = baseDay
    var baseDate: LocalDate? = null
    while (baseDate == null && d > 0) {
        try { baseDate = LocalDate(targetYear, targetMonth, d) } catch(e: Exception) { d-- }
    }

    // Simula lo slittamento
    return when (baseDate!!.dayOfWeek) {
        DayOfWeek.SATURDAY -> LocalDate.fromEpochDays(baseDate.toEpochDays() + 2)
        DayOfWeek.SUNDAY -> LocalDate.fromEpochDays(baseDate.toEpochDays() + 1)
        else -> baseDate
    }
}

@OptIn(ExperimentalFoundationApi::class, ExperimentalMaterial3Api::class)
@Composable
fun HomeScreen(
    safetyBufferCents: Long,
    onUpdateSafetyBuffer: (Long) -> Unit,
    emergencyTargetCents: Long, // ðŸš€ AGGIUNTO
    onUpdateEmergencyTarget: (Long) -> Unit, // ðŸš€ AGGIUNTO
    savingsTotalCents: Long,
    hideBalances: Boolean,
    onToggleHideBalances: () -> Unit,
    hiddenAccountIds: Set<String> = emptySet(),
    onToggleAccountHidden: (String) -> Unit,
    favorites: List<FavoriteTemplateEntity>,
    accounts: List<AccountEntity>,
    latest: List<TransactionEntity>,
    onSelectActive: (String) -> Unit,
    activeBalanceCents: Long,
    payPeriodStart: LocalDate,
    payPeriodEnd: LocalDate,
    totalFinancingRemainingCents: Long,
    activeAccountId: String?,
    activeAccountLogoEmoji: String? = null,
    activeAccountLogoUri: String? = null,
    committedRecurringCents: Long,
    committedFinancingCents: Long,
    recurringItems: List<RecurringExpenseEntity>,
    financingItems: List<FinancingEntity>,
    onPopupStateChanged: (Boolean) -> Unit = {},
    onOpenRecurring: () -> Unit,
    onGenerateRecurring: () -> Unit,
    onGenerateFinancing: () -> Unit,
    onOpenFinancings: () -> Unit,
    onOpenMovementsListForAccount: (String) -> Unit,
    onQuickAddActive: (String) -> Unit,
    onQuickAddSavings: (String) -> Unit,
    onQuickAddForAccount: (String, String) -> Unit,
    onApplyFavorite: (FavoriteTemplateEntity) -> Unit,
    onRequestDeleteFavorite: (FavoriteTemplateEntity) -> Unit,
    onCreateAccount: () -> Unit,
    onEditAccount: (AccountEntity) -> Unit,
    onRequestDelete: (AccountEntity) -> Unit,
    onUpdateAccount: (AccountEntity) -> Unit,
    onOpenSettings: () -> Unit,
    onForceSync: () -> Unit,
    onNukeAllData: () -> Unit,
    onOpenTrash: () -> Unit,
    onOpenCalculator: () -> Unit,
    onDismissTransaction: (TransactionEntity) -> Unit,
    onSaveTransaction: (TransactionEntity) -> Unit,
    onOpenDebtManager: () -> Unit,
    onPayRecurringEarly: (RecurringExpenseEntity) -> Unit = {},
    onUndoRecurringPayment: (RecurringExpenseEntity) -> Unit = {},
    onPayFinancingEarly: (FinancingEntity) -> Unit = {},
    onUndoFinancingPayment: (FinancingEntity) -> Unit = {},
    cleanName: String? = null,
    homeCardStepPx: Float = 0f,
    categories: List<CategoryEntity>,
    savingsAccountIds: Set<String>,
    savingsGoals: List<SavingsGoalEntity>,
    piggyBanks: List<PiggyBankEntity>,
    onAvailableBalanceCalculated: (Long) -> Unit = {},
    stats: MonthlyStats,
    accountingBalancesMap: Map<String, Long>,
    onProcessBankData: (amount: String, merchant: String, isIncome: Boolean) -> Unit = { _, _, _ -> },
    isGlobalPopupOpen: Boolean = false,
    onHideBalancesChange: (Boolean) -> Unit = {}
) {
    val listState = rememberLazyListState()
    val scope = rememberCoroutineScope()
    val haptic = LocalHapticFeedback.current

    var topBarMenuExpanded by rememberSaveable { mutableStateOf(false) }
    val clipboardManager = LocalClipboardManager.current

    // ðŸš€ FIX: Si espande SOLO quando la lista à¨ letteralmente a fine corsa (in cima)
    val isCollapsed by remember {
        derivedStateOf {
            listState.firstVisibleItemIndex > 0 || listState.firstVisibleItemScrollOffset > 10
        }
    }

    var showNukePrompt by rememberSaveable { mutableStateOf(false) }
    var showSignOutPrompt by rememberSaveable { mutableStateOf(false) }
    var showAccantonatiPopup by rememberSaveable { mutableStateOf(false) }
    val snackbarHostState = remember { SnackbarHostState() }
    val brandPrimary = MaterialTheme.colorScheme.primary

    var showAccountSelector by rememberSaveable { mutableStateOf(false) }
    var showRecurringExpenseSheet by rememberSaveable { mutableStateOf(false) }
    var showRecurringIncomeSheet by rememberSaveable { mutableStateOf(false) }
    var showFinancingSheet by rememberSaveable { mutableStateOf(false) }

    // ðŸš€ STATI FONDO DI EMERGENZA
    val settings = remember { Settings() }
    //var emergencyTargetCents by remember { mutableStateOf(settings.getLong("emergency_fund_target", 500000L)) }
    var showEmergencySheet by rememberSaveable { mutableStateOf(false) }
    var showEmergencySettingsDialog by rememberSaveable { mutableStateOf(false) }
    var emergencyActionType by rememberSaveable { mutableStateOf<String?>(null) } // NUOVO STATO

    val currentIbanAccount = accounts.firstOrNull { it.id == activeAccountId } ?: accounts.firstOrNull { !it.isDeleted && !it.isArchived }

    var localHideBalances by remember(hideBalances) { mutableStateOf(hideBalances) }

    // IBAN Sync State (Per singolo conto)
    var savedIban by remember(currentIbanAccount) { mutableStateOf(currentIbanAccount?.let { acc -> settings.getString("user_iban_${acc.id}", "") } ?: "") }
    var showIbanDialog by rememberSaveable { mutableStateOf(false) }

    // ðŸš€ STATI SICUREZZA VAULT / PIN
    var isVaultUnlocked by rememberSaveable { mutableStateOf(false) }
    var savedPin by remember { mutableStateOf(settings.getString("vault_pin", "")) }
    var showPinDialog by rememberSaveable { mutableStateOf(false) }
    var pinFlowMode by remember { mutableStateOf("ENTER") }
    var tempPin by remember { mutableStateOf("") }
    var pinInput by remember { mutableStateOf("") }
    var pinError by remember { mutableStateOf("") }

    val accountSheetState = rememberModalBottomSheetState(skipPartiallyExpanded = true)
    val recurringExpenseSheetState = rememberModalBottomSheetState(skipPartiallyExpanded = true)
    val recurringIncomeSheetState = rememberModalBottomSheetState(skipPartiallyExpanded = true)
    val financingSheetState = rememberModalBottomSheetState(skipPartiallyExpanded = true)
    val notificationSheetState = rememberModalBottomSheetState(skipPartiallyExpanded = true)

    var archivedExpanded by rememberSaveable { mutableStateOf(false) }
    var hiddenExpanded by rememberSaveable { mutableStateOf(false) }

    var isEditFavoritesMode by remember { mutableStateOf(false) }
    var favoriteToRemove by remember { mutableStateOf<FavoriteTemplateEntity?>(null) }
    var accountToDelete by remember { mutableStateOf<AccountEntity?>(null) }
    var accountToVault by remember { mutableStateOf<AccountEntity?>(null) }
    var accountToArchive by remember { mutableStateOf<AccountEntity?>(null) }
    var accountToUnvault by remember { mutableStateOf<AccountEntity?>(null) }
    var accountToUnarchive by remember { mutableStateOf<AccountEntity?>(null) }

    var recurringToPay by remember { mutableStateOf<RecurringExpenseEntity?>(null) }
    var recurringToUndo by remember { mutableStateOf<RecurringExpenseEntity?>(null) }
    var financingToPay by remember { mutableStateOf<FinancingEntity?>(null) }
    var financingToUndo by remember { mutableStateOf<FinancingEntity?>(null) }

    var showNotificationsSheet by rememberSaveable { mutableStateOf(false) }
    var dismissedNotificationIds by remember { mutableStateOf(setOf<String>()) }

    var activeBreakdownType by rememberSaveable { mutableStateOf<String?>(null) }

    val listVisibili = accounts.filter { !it.isDeleted && !it.isArchived && it.isVisible }
    val listNascosti = accounts.filter { !it.isDeleted && !it.isArchived && !it.isVisible }
    val listArchiviati = accounts.filter { !it.isDeleted && it.isArchived }
    val orderedVisibili = listVisibili

    val activeAccountName = accounts.firstOrNull { it.id == activeAccountId }?.name ?: "Tutti i conti"

    val today = Clock.System.todayIn(TimeZone.currentSystemDefault())
    val greetingText = remember {
        val hour = Clock.System.now().toLocalDateTime(TimeZone.currentSystemDefault()).hour
        when {
            hour in 5..12 -> {
                if (!hasSeenMorningGreetingInSession) {
                    hasSeenMorningGreetingInSession = true
                    "Buongiorno,"
                } else {
                    "Bentornato,"
                }
            }
            hour in 13..17 -> "Buon pomeriggio,"
            else -> "Buonasera,"
        }
    }
    val todayEpoch = today.toEpochDays().toLong()

    // ðŸš€ SCARICA IL PIN, LO SCUDO E L'IBAN DA FIREBASE (Sync)
    LaunchedEffect(Unit) {
        val helper = com.example.monetix.db.FirestoreHelper()
        helper.getPreferenze().collect { prefs ->
            if (prefs != null) {
                val cloudPin = prefs.vaultPin ?: ""
                if (cloudPin.isNotEmpty() && cloudPin != savedPin) {
                    settings.putString("vault_pin", cloudPin)
                    savedPin = cloudPin
                } else if (cloudPin.isEmpty() && savedPin.isNotEmpty()) {
                    settings.remove("vault_pin")
                    savedPin = ""
                }
                
                val cloudIban = prefs.userIban ?: ""
                if (cloudIban.isNotEmpty() && cloudIban != savedIban) {
                    settings.putString("user_iban", cloudIban)
                    savedIban = cloudIban
                }
            }
        }
    }

    LaunchedEffect(accounts, currentIbanAccount) {
        val helper = FirestoreHelper()
        helper.scaricaAccountBankDetails().collect { cloudDetailsMap ->
            cloudDetailsMap.forEach { (accId, map) ->
                map["type"]?.let { if (it.isNotBlank()) settings.putString("iban_${accId}_type", it) }
                map["iban"]?.let { if (it.isNotBlank()) settings.putString("user_iban_$accId", it) }
                map["holder"]?.let { if (it.isNotBlank()) settings.putString("iban_${accId}_holder", it) }
                map["country"]?.let { if (it.isNotBlank()) settings.putString("iban_${accId}_country", it) }
                map["cinEu"]?.let { if (it.isNotBlank()) settings.putString("iban_${accId}_cin_eu", it) }
                map["cinIt"]?.let { if (it.isNotBlank()) settings.putString("iban_${accId}_cin_it", it) }
                map["abi"]?.let { if (it.isNotBlank()) settings.putString("iban_${accId}_abi", it) }
                map["cab"]?.let { if (it.isNotBlank()) settings.putString("iban_${accId}_cab", it) }
                map["cc"]?.let { if (it.isNotBlank()) settings.putString("iban_${accId}_cc", it) }
                map["bic"]?.let { if (it.isNotBlank()) settings.putString("iban_${accId}_bic", it) }
                map["cardNum"]?.let { if (it.isNotBlank()) settings.putString("iban_${accId}_card_num", it) }
                map["cardExp"]?.let { if (it.isNotBlank()) settings.putString("iban_${accId}_card_exp", it) }
                map["cardCircuit"]?.let { if (it.isNotBlank()) settings.putString("iban_${accId}_card_circuit", it) }
                map["bookletNum"]?.let { if (it.isNotBlank()) settings.putString("iban_${accId}_booklet_num", it) }
                map["bookletOffice"]?.let { if (it.isNotBlank()) settings.putString("iban_${accId}_booklet_office", it) }
            }
            currentIbanAccount?.let { acc ->
                val type = settings.getString("iban_${acc.id}_type", "IBAN")
                savedIban = when (type) {
                    "CARD" -> settings.getString("iban_${acc.id}_card_num", "")
                    "BOOKLET" -> settings.getString("iban_${acc.id}_booklet_num", "")
                    else -> settings.getString("user_iban_${acc.id}", "")
                }
            }
        }
    }

    // ðŸš€ CALCOLO FONDO DI EMERGENZA
    val emergencyTxs = remember(latest) {
        latest.filter { !it.isDeleted && (it.accountId == "sys_emergency_fund" || it.toAccountId == "sys_emergency_fund" || it.fromAccountId == "sys_emergency_fund") }
    }
    val emergencyBalanceCents = remember(emergencyTxs, todayEpoch, activeAccountId) {
        var sum = 0L
        for (tx in emergencyTxs) {
            if (tx.dateEpochDay > todayEpoch) continue

            if (activeAccountId == null) {
                // Vista Globale
                when (tx.type) {
                    "INCOME" -> if (tx.accountId == "sys_emergency_fund") sum += tx.amountCents
                    "EXPENSE" -> if (tx.accountId == "sys_emergency_fund") sum -= tx.amountCents
                    "TRANSFER" -> {
                        if (tx.fromAccountId == "sys_emergency_fund") sum -= tx.amountCents
                        if (tx.toAccountId == "sys_emergency_fund") sum += tx.amountCents
                    }
                }
            } else {
                // Vista per Conto: Quota dello scudo originata da questo conto
                if (tx.type == "TRANSFER") {
                    if (tx.fromAccountId == activeAccountId && tx.toAccountId == "sys_emergency_fund") {
                        sum += tx.amountCents
                    } else if (tx.fromAccountId == "sys_emergency_fund" && tx.toAccountId == activeAccountId) {
                        sum -= tx.amountCents
                    }
                }
            }
        }
        sum
    }

    val emergencyAlerts = remember(emergencyTxs, dismissedNotificationIds) {
        emergencyTxs.filter { tx ->
            val isWithdrawal = (tx.type == "EXPENSE" && tx.accountId == "sys_emergency_fund") || (tx.type == "TRANSFER" && tx.fromAccountId == "sys_emergency_fund")
            isWithdrawal && tx.id !in dismissedNotificationIds
        }.sortedByDescending { it.dateEpochDay }
    }

    fun calculateBalanceFromLatest(targetAccountId: String?, maxEpochDay: Long): Long {
        var sum = 0L
        val activeAccountIds = accounts.filter { !it.isDeleted }.map { it.id }.toSet()

        for (tx in latest) {
            if (tx.isDeleted || tx.dateEpochDay > maxEpochDay) continue

            val isToSavingsAcc = tx.type == "TRANSFER" && tx.toAccountId != null && accounts.any { it.id == tx.toAccountId && it.isSavings }
            val isFutureSavings = tx.dateEpochDay > todayEpoch && (
                    tx.merchantKey?.contains("[pb:", ignoreCase = true) == true ||
                            tx.merchantKey?.contains("[sav:", ignoreCase = true) == true ||
                            tx.merchantKey?.contains("[goal:", ignoreCase = true) == true ||
                            tx.merchantKey?.contains("[pac_sav:", ignoreCase = true) == true ||
                            tx.merchantKey?.contains("salvadanaio", ignoreCase = true) == true ||
                            tx.description?.contains("[pb:", ignoreCase = true) == true ||
                            tx.description?.contains("[sav:", ignoreCase = true) == true ||
                            tx.description?.contains("[goal:", ignoreCase = true) == true ||
                            tx.description?.contains("[pac_sav:", ignoreCase = true) == true ||
                            tx.description?.contains("salvadanaio", ignoreCase = true) == true ||
                            isToSavingsAcc
                    )
            if (isFutureSavings) continue

            if (targetAccountId == null) {
                val isMainActive = tx.accountId in activeAccountIds
                val isFromActive = tx.fromAccountId in activeAccountIds
                val isToActive = tx.toAccountId in activeAccountIds

                when (tx.type) {
                    "INCOME" -> if (isMainActive && tx.dateEpochDay <= todayEpoch) sum += tx.amountCents
                    "EXPENSE" -> if (isMainActive) sum -= tx.amountCents
                    "TRANSFER" -> {
                        if (isFromActive && !isToActive) sum -= tx.amountCents
                        else if (!isFromActive && isToActive && tx.dateEpochDay <= todayEpoch) sum += tx.amountCents
                    }
                }
            } else {
                when (tx.type) {
                    "INCOME" -> if (tx.accountId == targetAccountId && tx.dateEpochDay <= todayEpoch) sum += tx.amountCents
                    "EXPENSE" -> if (tx.accountId == targetAccountId) sum -= tx.amountCents
                    "TRANSFER" -> {
                        if (tx.fromAccountId == targetAccountId) sum -= tx.amountCents
                        if (tx.toAccountId == targetAccountId && tx.dateEpochDay <= todayEpoch) sum += tx.amountCents
                    }
                }
            }
        }
        return sum
    }

    val accountingPeriodEnd = payPeriodEnd
    val periodEndEpoch = accountingPeriodEnd.toEpochDays().toLong()

    fun calculateAccountAvailable(accId: String): Long {
        val pStartEpoch = payPeriodStart.toEpochDays().toLong()
        val accUnpaidRec = recurringItems.filter { rec ->
            val isCartella = rec.notes?.contains("[CART:", ignoreCase = true) == true || rec.notes?.contains("[TAX:", ignoreCase = true) == true || rec.id.startsWith("cart_") || rec.id.startsWith("tax_")
            !rec.isDeleted && rec.isEnabled && rec.type != "INCOME" && rec.nextEpochDay <= periodEndEpoch &&
                    (rec.accountId == accId || rec.accountId == "NEW_TAX_MODE" || rec.accountId.isNullOrBlank() || (activeAccountId == null)) && !isCartella
        }.sumOf { rec ->
            val hasPaidThisMonth = latest.any { tx ->
                !tx.isDeleted && tx.dateEpochDay >= pStartEpoch &&
                        (tx.description?.contains("[rec:${rec.id}]", ignoreCase = true) == true || tx.merchantKey?.contains("[rec:${rec.id}]", ignoreCase = true) == true)
            }
            if (hasPaidThisMonth) 0L else rec.amountCents
        }

        val accUnpaidFin = financingItems.filter { fin ->
            !fin.isDeleted && !fin.isClosed && (fin.accountId == accId || (fin.accountId.isNullOrBlank() && activeAccountId == null))
        }.sumOf { fin ->
            val hasPaidThisMonth = latest.any { tx ->
                !tx.isDeleted && tx.dateEpochDay >= pStartEpoch &&
                        (tx.description?.contains("[fin:${fin.id}]", ignoreCase = true) == true || tx.merchantKey?.contains("[fin:${fin.id}]", ignoreCase = true) == true)
            }
            if (hasPaidThisMonth) 0L else (fin.installmentAmountCents + (fin.commissionCents ?: 0L))
        }

        val accUnpaidCartelle = recurringItems.filter { rec ->
            val isCartella = rec.notes?.contains("[CART:", ignoreCase = true) == true || rec.notes?.contains("[TAX:", ignoreCase = true) == true || rec.id.startsWith("cart_") || rec.id.startsWith("tax_")
            !rec.isDeleted && rec.isEnabled && isCartella &&
                    (rec.accountId == accId || rec.accountId == "NEW_TAX_MODE" || rec.accountId.isNullOrBlank() || (activeAccountId == null))
        }.mapNotNull { rec ->
            val match = Regex("\\[(?:CART|TAX):([^\\]]*)\\]", RegexOption.IGNORE_CASE).find(rec.notes ?: "")
            val rates = match?.groupValues?.get(1)?.split(",")?.map { it.trim() }?.filter { it.isNotBlank() } ?: emptyList()
            val firstUnpaid = rates.firstOrNull { !it.endsWith(":P", ignoreCase = true) && !it.endsWith(":X", ignoreCase = true) }
            val baseAmtStr = firstUnpaid?.split("@")?.firstOrNull() ?: firstUnpaid
            val amt = baseAmtStr?.replace(Regex(":[PX]", RegexOption.IGNORE_CASE), "")?.toLongOrNull() ?: 0L
            val isPaidThisMonth = rec.nextEpochDay > periodEndEpoch
            if (amt > 0L && !isPaidThisMonth) amt else null
        }.sum()

        val accRawBal = calculateBalanceFromLatest(accId, periodEndEpoch)
        return accRawBal - accUnpaidRec - accUnpaidFin - accUnpaidCartelle
    }

    val currentAccounting = calculateBalanceFromLatest(activeAccountId, todayEpoch)
    val baseAvailable = calculateBalanceFromLatest(activeAccountId, periodEndEpoch)

    val upcomingAlerts = remember(latest, todayEpoch, dismissedNotificationIds, stats, recurringItems, periodEndEpoch, activeAccountId) {
        val alerts = mutableListOf<Pair<String, TransactionEntity>>()
        val unpaidRecIds = recurringItems.filter { !it.isDeleted && it.isEnabled && it.nextEpochDay <= periodEndEpoch && (activeAccountId == null || it.accountId == activeAccountId) }.map { it.id }.toSet()
        val unpaidFinIds = stats.unpaidFinancingList.filter { activeAccountId == null || it.accountId == activeAccountId }.map { it.id }.toSet()

        latest.filter { tx ->
            val isBasicValid = !tx.isDeleted &&
                    tx.dateEpochDay > todayEpoch &&
                    tx.dateEpochDay <= todayEpoch + 7 &&
                    (tx.reminderDays ?: 0L) >= 0L &&
                    tx.id !in dismissedNotificationIds
            if (!isBasicValid) return@filter false

            val desc = tx.description ?: ""
            val merch = tx.merchantKey ?: ""
            val recId = Regex("\\[rec:([^\\]]+)\\]").find(desc)?.groupValues?.get(1) ?: Regex("\\[rec:([^\\]]+)\\]").find(merch)?.groupValues?.get(1)
            val finId = Regex("\\[fin:([^\\]]+)\\]").find(desc)?.groupValues?.get(1) ?: Regex("\\[fin:([^\\]]+)\\]").find(merch)?.groupValues?.get(1)

            if (recId != null && recId !in unpaidRecIds) return@filter false
            if (finId != null && finId !in unpaidFinIds) return@filter false
            true
        }.forEach { tx ->
            val daysDiff = tx.dateEpochDay - todayEpoch
            val label = when(daysDiff) {
                1L -> "Domani"
                else -> "Tra $daysDiff giorni"
            }
            alerts.add(label to tx)
        }
        alerts.sortedBy { it.second.dateEpochDay }
    }

    val bankNotifsTrigger = BankNotificationCatcher.hasNewNotification
    val bankNotifs = BankNotificationCatcher.pendingQueue.toList()
    val totalNotifications = upcomingAlerts.size + bankNotifs.size + emergencyAlerts.size
    val hasNotifications = totalNotifications > 0

    // ==============================================================================
    // ðŸš€ MOTORE LIQUIDITà€ E IMPEGNI (PULITO E CON I MOVIMENTI IN ARRIVO ACCORPATI)
    // ==============================================================================

    // 1. Sogni Manuali
    val activeSogniList = remember(savingsGoals, latest, todayEpoch, activeAccountId, accounts) {
        savingsGoals.filter { !it.isDeleted && !it.isCompleted && !it.name.contains("[PAC:") && (activeAccountId == null || belongsToAccount(it.name, activeAccountId, accounts)) }.mapNotNull { goal ->
            val amount = latest.filter { tx ->
                !tx.isDeleted && tx.dateEpochDay <= todayEpoch &&
                        (tx.merchantKey?.contains(":${goal.id}]") == true || tx.description?.contains(":${goal.id}]") == true) &&
                        (activeAccountId == null || tx.accountId == activeAccountId || tx.fromAccountId == activeAccountId || tx.accountId == "salvadanaio_virtuale" || tx.fromAccountId == "salvadanaio_virtuale")
            }.fold(0L) { acc, tx ->
                val isDeposit = (tx.type == "EXPENSE" && tx.amountCents > 0) || (tx.type == "TRANSFER" && tx.fromAccountId != "salvadanaio_virtuale")
                val isWithdrawal = tx.type == "EXPENSE" && tx.amountCents < 0
                val isTransferOut = tx.type == "TRANSFER" && tx.fromAccountId == "salvadanaio_virtuale"
                val isIncomeUnlock = tx.type == "INCOME"
                acc + when {
                    isDeposit -> tx.amountCents
                    isWithdrawal -> tx.amountCents
                    isTransferOut -> -tx.amountCents
                    isIncomeUnlock -> -tx.amountCents
                    else -> 0L
                }
            }.coerceAtLeast(0L)
            
            if (amount > 0L) (goal.name.replace(Regex("\\[(PAC|ACC):.*?\\]"), "").trim().ifBlank { "Sogno" }) to amount else null
        }
    }
    val totalSogni = activeSogniList.fold(0L) { acc, it -> acc + it.second }

    // 2. Smart PAC Automatici
    val activePacList = remember(savingsGoals, latest, todayEpoch, activeAccountId, accounts) {
        savingsGoals.filter { !it.isDeleted && !it.isCompleted && it.name.contains("[PAC:") && (activeAccountId == null || belongsToAccount(it.name, activeAccountId, accounts)) }.mapNotNull { pac ->
            val amount = latest.filter { tx ->
                !tx.isDeleted && tx.dateEpochDay <= todayEpoch &&
                        (tx.merchantKey?.contains(":${pac.id}]") == true || tx.description?.contains(":${pac.id}]") == true) &&
                        (activeAccountId == null || tx.accountId == activeAccountId || tx.fromAccountId == activeAccountId || tx.accountId == "salvadanaio_virtuale" || tx.fromAccountId == "salvadanaio_virtuale")
            }.fold(0L) { acc, tx ->
                val isDeposit = (tx.type == "EXPENSE" && tx.amountCents > 0) || (tx.type == "TRANSFER" && tx.fromAccountId != "salvadanaio_virtuale")
                val isWithdrawal = tx.type == "EXPENSE" && tx.amountCents < 0
                val isTransferOut = tx.type == "TRANSFER" && tx.fromAccountId == "salvadanaio_virtuale"
                val isIncomeUnlock = tx.type == "INCOME"
                acc + when {
                    isDeposit -> tx.amountCents
                    isWithdrawal -> tx.amountCents
                    isTransferOut -> -tx.amountCents
                    isIncomeUnlock -> -tx.amountCents
                    else -> 0L
                }
            }.coerceAtLeast(0L)
            
            if (amount > 0L) (pac.name.replace(Regex("\\[(PAC|ACC):.*?\\]"), "").trim().ifBlank { "Smart PAC" }) to amount else null
        }
    }
    val totalPac = activePacList.fold(0L) { acc, it -> acc + it.second }

    // 3. Salvadanai Virtuali
    val activeSalvadanaiList = remember(piggyBanks, latest, todayEpoch, activeAccountId, accounts) {
        piggyBanks.filter { !it.isDeleted && (activeAccountId == null || belongsToAccount(it.name, activeAccountId, accounts)) }.mapNotNull { bank ->
            val amount = latest.filter { tx ->
                !tx.isDeleted && tx.dateEpochDay <= todayEpoch &&
                        (tx.merchantKey?.contains(":${bank.id}]") == true || tx.description?.contains(":${bank.id}]") == true) &&
                        (activeAccountId == null || tx.accountId == activeAccountId || tx.fromAccountId == activeAccountId || tx.accountId == "salvadanaio_virtuale" || tx.fromAccountId == "salvadanaio_virtuale")
            }.fold(0L) { acc, tx ->
                val isDeposit = (tx.type == "EXPENSE" && tx.amountCents > 0) || (tx.type == "TRANSFER" && tx.fromAccountId != "salvadanaio_virtuale")
                val isWithdrawal = tx.type == "EXPENSE" && tx.amountCents < 0
                val isTransferOut = tx.type == "TRANSFER" && tx.fromAccountId == "salvadanaio_virtuale"
                val isIncomeUnlock = tx.type == "INCOME"
                acc + when {
                    isDeposit -> tx.amountCents
                    isWithdrawal -> tx.amountCents
                    isTransferOut -> -tx.amountCents
                    isIncomeUnlock -> -tx.amountCents
                    else -> 0L
                }
            }.coerceAtLeast(0L)
            if (amount > 0L) (bank.name.replace(Regex("\\[(PAC|ACC):.*?\\]"), "").trim().ifBlank { "Salvadanaio" }) to amount else null
        }
    }
    val totalSalvadanai = activeSalvadanaiList.fold(0L) { acc, it -> acc + it.second }

    // 2. Cartelle Esattoriali / Tasse
    val activeCartelleList = remember(recurringItems, activeAccountId, periodEndEpoch) {
        recurringItems.filter { rec ->
            val isCartella = rec.notes?.contains("[CART:", ignoreCase = true) == true || rec.notes?.contains("[TAX:", ignoreCase = true) == true || rec.id.startsWith("cart_") || rec.id.startsWith("tax_")
            val matchesAccount = activeAccountId == null || rec.accountId == activeAccountId || rec.accountId == "NEW_TAX_MODE" || rec.accountId.isNullOrBlank()
            !rec.isDeleted && isCartella && matchesAccount
        }.mapNotNull { rec ->
            val match = Regex("\\[(?:CART|TAX):([^\\]]*)\\]", RegexOption.IGNORE_CASE).find(rec.notes ?: "")
            val rates = match?.groupValues?.get(1)?.split(",")?.map { it.trim() }?.filter { it.isNotBlank() } ?: emptyList()
            val firstUnpaid = rates.firstOrNull { !it.endsWith(":P", ignoreCase = true) && !it.endsWith(":X", ignoreCase = true) }
            val baseAmtStr = firstUnpaid?.split("@")?.firstOrNull() ?: firstUnpaid
            val amt = baseAmtStr?.replace(Regex(":[PX]", RegexOption.IGNORE_CASE), "")?.toLongOrNull() ?: 0L
            val isPaidThisMonth = rec.nextEpochDay > periodEndEpoch
            if (amt > 0L && !isPaidThisMonth) (rec.name ?: "Cartella / Tassa") to amt else null
        }
    }
    val totalCartelleMese = activeCartelleList.fold(0L) { acc, it -> acc + it.second }

    // 3. Scadenze Mese
    val activeScadenzeMeseList = remember(recurringItems, latest, activeAccountId, payPeriodStart, periodEndEpoch, accounts, stats.unpaidFinancingList) {
        val pStartEpoch = payPeriodStart.toEpochDays().toLong()
        val recScadenze = recurringItems.filter { rec ->
            val isCartella = rec.notes?.contains("[CART:", ignoreCase = true) == true || rec.notes?.contains("[TAX:", ignoreCase = true) == true || rec.id.startsWith("cart_") || rec.id.startsWith("tax_")

            !rec.isDeleted && rec.isEnabled && rec.type != "INCOME" && rec.nextEpochDay <= periodEndEpoch &&
                    (activeAccountId == null || rec.accountId == activeAccountId) &&
                    !isCartella
        }.mapNotNull { rec ->
            // ðŸš€ FIX CRUCIALE (MODIFICATO): Cerchiamo la transazione in tutto il db `latest` invece che solo nel periodo limitato, 
            // ma controlliamo che la transazione stessa sia stata emessa _dopo_ l'inizio del mese contabile o _nel_ mese contabile
            val hasPaidThisMonth = latest.any { tx ->
                !tx.isDeleted && tx.dateEpochDay >= pStartEpoch &&
                        (tx.description?.contains("[rec:${rec.id}]", ignoreCase = true) == true || tx.merchantKey?.contains("[rec:${rec.id}]", ignoreCase = true) == true)
            }
            if (hasPaidThisMonth) return@mapNotNull null
            
            (rec.name ?: "Spesa Fissa") to rec.amountCents
        }

        val finScadenze = stats.unpaidFinancingList.filter { activeAccountId == null || it.accountId == activeAccountId }.map {
            (it.name ?: "Rata") to (it.installmentAmountCents + (it.commissionCents ?: 0L))
        }
        recScadenze + finScadenze
    }
    val unpaidFixed = activeScadenzeMeseList.fold(0L) { acc, it -> acc + it.second }
    val totalScadenzeMese = unpaidFixed + totalCartelleMese

// 4. Cicli Mensili
    val activeSinkingFundsList = remember(recurringItems, latest, todayEpoch, activeAccountId) {
        recurringItems.filter { rec ->
            val isCartella = rec.notes?.contains("[CART:", ignoreCase = true) == true || rec.notes?.contains("[TAX:", ignoreCase = true) == true || rec.id.startsWith("cart_") || rec.id.startsWith("tax_")
            !rec.isDeleted && rec.isEnabled && (rec.cycleTarget ?: 0) > 0 && rec.type != "INCOME" &&
                    (activeAccountId == null || rec.accountId == activeAccountId) && !isCartella
        }.mapNotNull { rec ->
            val target = rec.cycleTarget ?: 0
            val count = latest.count { tx ->
                !tx.isDeleted &&
                        // ðŸš€ FIX: Tolto il limite di data!
                        (tx.description?.contains("[rec:${rec.id}") == true || tx.merchantKey?.contains("[rec:${rec.id}") == true) &&
                        (activeAccountId == null || tx.accountId == activeAccountId || tx.fromAccountId == activeAccountId)
            }.toLong()
            val currentStep = if (count == 0L) 0L else if (count % target == 0L) target.toLong() else count % target
            val amount = currentStep * rec.amountCents
            if (amount > 0L) (rec.name ?: "Ciclo Mensile") to amount else null
        }
    }
    val cicliPositivi = activeSinkingFundsList.fold(0L) { acc, it -> acc + it.second }
    // 5. Movimenti Fantasma
    val programmatiBreakdown = remember(latest, activeAccountId) {
        latest.filter { tx ->
            !tx.isDeleted &&
                    (tx.accountId?.startsWith("sys_ghost_") == true || tx.fromAccountId?.startsWith("sys_ghost_") == true || tx.toAccountId?.startsWith("sys_ghost_") == true || tx.accountId == "sys_ghost_tracker_account") &&
                    !(tx.description?.contains("[cash:", ignoreCase = true) == true || tx.merchantKey?.contains("[cash:", ignoreCase = true) == true) &&
                    !(tx.description?.contains("[exp:", ignoreCase = true) == true || tx.merchantKey?.contains("[exp:", ignoreCase = true) == true) &&
                    !(tx.description?.contains("[pb:", ignoreCase = true) == true || tx.merchantKey?.contains("[pb:", ignoreCase = true) == true) &&
                    !(tx.description?.contains("[sav:", ignoreCase = true) == true || tx.merchantKey?.contains("[sav:", ignoreCase = true) == true) &&
                    !(tx.description?.contains("[goal:", ignoreCase = true) == true || tx.merchantKey?.contains("[goal:", ignoreCase = true) == true) &&
                    (activeAccountId == null || tx.accountId == activeAccountId || tx.fromAccountId == activeAccountId)
        }.mapNotNull { tx ->
            val isExpense = tx.type == "EXPENSE" && (tx.accountId?.startsWith("sys_ghost_") == true || tx.accountId == "sys_ghost_tracker_account")
            val isTransferOut = tx.type == "TRANSFER" && (tx.fromAccountId?.startsWith("sys_ghost_") == true || tx.fromAccountId == "sys_ghost_tracker_account")
            if (isExpense || isTransferOut) {
                val rawName = tx.merchantKey ?: tx.description ?: "Movimento Fantasma"
                val cleanName = rawName.replace(Regex("\\[.*?\\]"), "").trim().ifBlank { "Movimento Fantasma" }
                cleanName to (if (tx.amountCents < 0L) -tx.amountCents else tx.amountCents)
            } else null
        }.filter { it.second > 0L }
    }
    val movimentiFantasmaCents = programmatiBreakdown.fold(0L) { acc, it -> acc + it.second }

    // ðŸš€ 6. MOVIMENTI IN ARRIVO (RATE E SPESE FISSE GIÀ€ AUTO-GENERATE)
    val movimentiInArrivoBreakdown = remember(latest, todayEpoch, periodEndEpoch, activeAccountId, accounts) {
        val activeAccountIds = accounts.filter { !it.isDeleted }.map { it.id }.toSet()
        latest.filter { tx ->
            val isToSavingsAcc = tx.type == "TRANSFER" && tx.toAccountId != null && accounts.any { it.id == tx.toAccountId && it.isSavings }
            val isFutureSavings = tx.dateEpochDay > todayEpoch && (
                    tx.merchantKey?.contains("[pb:", ignoreCase = true) == true ||
                            tx.merchantKey?.contains("[sav:", ignoreCase = true) == true ||
                            tx.merchantKey?.contains("[goal:", ignoreCase = true) == true ||
                            tx.merchantKey?.contains("[pac_sav:", ignoreCase = true) == true ||
                            tx.merchantKey?.contains("salvadanaio", ignoreCase = true) == true ||
                            tx.description?.contains("[pb:", ignoreCase = true) == true ||
                            tx.description?.contains("[sav:", ignoreCase = true) == true ||
                            tx.description?.contains("[goal:", ignoreCase = true) == true ||
                            tx.description?.contains("[pac_sav:", ignoreCase = true) == true ||
                            tx.description?.contains("salvadanaio", ignoreCase = true) == true ||
                            isToSavingsAcc
                    )

            !tx.isDeleted &&
                    tx.dateEpochDay > todayEpoch &&
                    tx.dateEpochDay <= periodEndEpoch &&
                    tx.type != "INCOME" &&
                    !tx.accountId.orEmpty().startsWith("sys_ghost_") &&
                    !tx.fromAccountId.orEmpty().startsWith("sys_ghost_") &&
                    !isFutureSavings &&
                    (activeAccountId == null || tx.accountId == activeAccountId || tx.fromAccountId == activeAccountId)
        }.mapNotNull { tx ->
            val amt = tx.amountCents
            if (amt > 0L) {
                // ðŸš€ FIX: Puliamo il nome dai tag grafici
                val rawName = tx.merchantKey ?: tx.description ?: "Movimento in arrivo"
                val cleanName = rawName.replace(Regex("\\[.*?\\]"), "").trim().ifBlank { "Movimento in arrivo" }
                cleanName to amt
            } else null
        }
    }
    val movimentiInArrivoCents = movimentiInArrivoBreakdown.fold(0L) { acc, it -> acc + it.second }

    // -> CALCOLI FINALI DI MATEMATICA VISIVA E AUTO-DRAIN DELLO SCUDO
    val impegniVisivi = totalScadenzeMese + movimentiInArrivoCents
    val totalAccantonato = totalSogni + totalPac + totalScadenzeMese + cicliPositivi + totalSalvadanai + movimentiFantasmaCents + movimentiInArrivoCents + emergencyBalanceCents

    val rawAvailable = baseAvailable - totalScadenzeMese
    val deficit = if (rawAvailable < 0L) abs(rawAvailable) else 0L
    val scudoIntervento = minOf(deficit, emergencyBalanceCents)

    val currentAvailable = rawAvailable + scudoIntervento
    val emergencyVisibile = emergencyBalanceCents - scudoIntervento

    // ðŸš€ FIX: Il Saldo Contabile (Visibile in Banca) DEVE includere i fondi virtuali reali (Sogni, PAC, Salvadanai, Scudo)
    val saldoContabile = rawAvailable + impegniVisivi + totalSogni + totalPac + totalSalvadanai + emergencyBalanceCents

    var showSafetyBufferDialog by rememberSaveable { mutableStateOf(false) }
    val isIntaccandoScorta = currentAvailable < safetyBufferCents
    val scortaUsata = if (isIntaccandoScorta) safetyBufferCents - currentAvailable.coerceAtLeast(0L) else 0L

    val netDebtBalance = remember(latest) {
        latest.filter { tx -> !tx.isDeleted && tx.categoryId == "sys_debt_category" }
            .fold(0L) { acc, it -> acc + if (it.toAccountId == "sys_debt_manager_account") it.amountCents else -it.amountCents }
    }

    val daysRemaining = maxOf(1L, (payPeriodEnd.toEpochDays().toLong() - todayEpoch) + 1)
    val safeToSpendDailyCents = if (currentAvailable > 0L) currentAvailable / daysRemaining else 0L

    val infiniteTransition = rememberInfiniteTransition()
    val bgOffset by infiniteTransition.animateFloat(
        initialValue = 0f,
        targetValue = 1000f,
        animationSpec = infiniteRepeatable(
            animation = tween(20000, easing = LinearEasing),
            repeatMode = RepeatMode.Reverse
        ),
        label = "bg_offset"
    )

    val isHomeScreenPopupOpen = showAccountSelector || showAccantonatiPopup || showSafetyBufferDialog ||
            showEmergencySheet || showNotificationsSheet || showIbanDialog ||
            showNukePrompt || showSignOutPrompt || activeBreakdownType != null ||
            showRecurringExpenseSheet || showRecurringIncomeSheet || showFinancingSheet ||
            recurringToPay != null || recurringToUndo != null || financingToPay != null || financingToUndo != null ||
            favoriteToRemove != null || accountToDelete != null || accountToVault != null || accountToArchive != null ||
            accountToUnvault != null || accountToUnarchive != null || showEmergencySettingsDialog || emergencyActionType != null || topBarMenuExpanded ||
            isGlobalPopupOpen

    LaunchedEffect(isHomeScreenPopupOpen) {
        onPopupStateChanged(isHomeScreenPopupOpen)
    }

    val backgroundBlur by animateDpAsState(
        targetValue = if (isHomeScreenPopupOpen) 12.dp else 0.dp,
        animationSpec = tween(durationMillis = 300),
        label = "homeBgBlur"
    )

    val hasCustomBg = com.example.monetix.LocalHasCustomBackground.current

    Box(
        modifier = Modifier
            .fillMaxSize()
            .then(
                if (hasCustomBg) Modifier.background(Color.Transparent)
                else Modifier.background(
                    Brush.verticalGradient(
                        colors = listOf(
                            Color(0xFF4F46E5).copy(alpha = 0.8f),
                            Color(0xFF1E1B4B),
                            Color(0xFF0F172A)
                        ),
                        startY = 0f,
                        endY = bgOffset + 1500f
                    )
                )
            )
            .blur(backgroundBlur)
    ) {
        Scaffold(
            containerColor = Color.Transparent,
            snackbarHost = {
                SnackbarHost(
                    hostState = snackbarHostState,
                    modifier = Modifier.padding(bottom = 120.dp)
                )
            }
        ) { paddingValues ->
            Column(modifier = Modifier.fillMaxSize().padding(paddingValues)) {

                // ðŸš€ HERO GREETING COME REVOLUT IN ALTO!
                Row(
                    modifier = Modifier
                        .fillMaxWidth()
                        .statusBarsPadding()
                        .padding(horizontal = 24.dp, vertical = 12.dp),
                    horizontalArrangement = Arrangement.SpaceBetween,
                    verticalAlignment = Alignment.CenterVertically
                ) {
                    Column {
                        Text(
                            text = greetingText,
                            style = MaterialTheme.typography.labelMedium,
                            color = Color.White.copy(alpha = 0.7f)
                        )
                        Text(
                            text = (cleanName ?: "UTENTE").uppercase(),
                            style = MaterialTheme.typography.headlineSmall.copy(fontWeight = FontWeight.Black),
                            color = Color.White
                        )
                    }
                    Row(horizontalArrangement = Arrangement.spacedBy(8.dp), verticalAlignment = Alignment.CenterVertically) {
                        // ðŸ‘ï¸ OCCHIO PER OSCURARE I SALDI NELLA HOME (Stampato a schermo senza cerchio)
                        IconButton(
                            onClick = {
                                triggerHapticTick()
                                localHideBalances = !localHideBalances
                                onHideBalancesChange(localHideBalances)
                            }
                        ) {
                            Icon(
                                if (localHideBalances) Icons.Outlined.VisibilityOff else Icons.Outlined.Visibility,
                                contentDescription = "Oscura importi",
                                tint = Color.White
                            )
                        }

                        // ðŸš€ ICONA NOTIFICHE REALE DALLA HOME
                        val bankNotifsTrigger = BankNotificationCatcher.hasNewNotification
                        val bankNotifs = BankNotificationCatcher.pendingQueue.toList()
                        val totalNotifications = upcomingAlerts.size + bankNotifs.size + emergencyAlerts.size
                        val hasNotifications = totalNotifications > 0

                        IconButton(onClick = { showNotificationsSheet = true }) {
                            if (hasNotifications) {
                                BadgedBox(
                                    badge = {
                                        Badge(containerColor = MaterialTheme.colorScheme.error) {
                                            Text(totalNotifications.toString(), color = Color.White)
                                        }
                                    }
                                ) {
                                    Icon(Icons.Rounded.Notifications, contentDescription = "Notifiche", tint = Color.White)
                                }
                            } else {
                                Icon(Icons.Rounded.NotificationsNone, contentDescription = "Notifiche", tint = Color.White)
                            }
                        }

                        // ðŸš€ MENU A TENDINA GLOBALE DALLA HOME
                        Box {
                            IconButton(onClick = { topBarMenuExpanded = true }) {
                                Icon(Icons.Rounded.MoreVert, contentDescription = "Opzioni", tint = Color.White)
                            }

                            DropdownMenu(
                                expanded = topBarMenuExpanded,
                                onDismissRequest = { topBarMenuExpanded = false },
                                shape = RoundedCornerShape(20.dp),
                                containerColor = Color.White.copy(alpha = 0.15f),
                                border = BorderStroke(1.dp, Color.White.copy(alpha = 0.25f)),
                                shadowElevation = 0.dp,
                                tonalElevation = 0.dp
                            ) {
                                DropdownMenuItem(text = { Text("Calcolatrice", fontWeight = FontWeight.SemiBold, color = Color.White) }, leadingIcon = { Icon(Icons.Rounded.Calculate, null, tint = Color.White) }, onClick = { topBarMenuExpanded = false; onOpenCalculator() })
                                DropdownMenuItem(text = { Text("Sincronizza", fontWeight = FontWeight.SemiBold, color = Color.White) }, leadingIcon = { Icon(Icons.Rounded.CloudSync, null, tint = Color.White) }, onClick = { topBarMenuExpanded = false; onForceSync() })
                                DropdownMenuItem(text = { Text("Cestino", fontWeight = FontWeight.SemiBold, color = Color.White) }, leadingIcon = { Icon(Icons.Rounded.DeleteOutline, null, tint = Color.White) }, onClick = { topBarMenuExpanded = false; onOpenTrash() })
                                DropdownMenuItem(text = { Text("Impostazioni", fontWeight = FontWeight.SemiBold, color = Color.White) }, leadingIcon = { Icon(Icons.Rounded.Settings, null, tint = Color.White) }, onClick = { topBarMenuExpanded = false; onOpenSettings() })
                                HorizontalDivider(color = Color.White.copy(alpha = 0.15f))
                                DropdownMenuItem(text = { Text("Esci", fontWeight = FontWeight.Bold, color = Color(0xFFEF4444)) }, leadingIcon = { Icon(Icons.Rounded.Logout, null, tint = Color(0xFFEF4444)) }, onClick = { topBarMenuExpanded = false; showSignOutPrompt = true })
                                DropdownMenuItem(text = { Text("Elimina Tutto", fontWeight = FontWeight.Black, color = Color(0xFFDC2626)) }, leadingIcon = { Icon(Icons.Rounded.DeleteForever, null, tint = Color(0xFFDC2626)) }, onClick = { topBarMenuExpanded = false; showNukePrompt = true })
                            }
                        }
                    }
                }

                LazyColumn(
                    state = listState,
                    modifier = Modifier.fillMaxWidth().weight(1f),
                    contentPadding = PaddingValues(bottom = 16.dp)
                ) {

                    // ðŸš€ MAIN BALANCE (NON STICKY)
                    item {
                        Column(
                            modifier = Modifier
                                .fillMaxWidth()
                                .padding(top = 16.dp, bottom = 24.dp),
                            horizontalAlignment = Alignment.CenterHorizontally
                        ) {
                            // Tasto conti e nome al centro come Revolut
                            Surface(
                                shape = RoundedCornerShape(50),
                                color = Color.White.copy(alpha = 0.15f),
                                modifier = Modifier
                                    .clip(RoundedCornerShape(50))
                                    .clickable { triggerHapticTick(); showAccountSelector = true }
                                    .padding(vertical = 4.dp, horizontal = 12.dp)
                            ) {
                                Row(verticalAlignment = Alignment.CenterVertically, modifier = Modifier.padding(horizontal = 12.dp, vertical = 6.dp)) {
                                    TxLogo(activeAccountLogoEmoji?.takeIf { it.isNotBlank() }, activeAccountLogoUri?.takeIf { it.isNotBlank() }, activeAccountName, Modifier.size(16.dp))
                                    Spacer(Modifier.width(8.dp))
                                    Text(
                                        text = "$activeAccountName·€ EUR",
                                        style = MaterialTheme.typography.labelMedium.copy(fontWeight = FontWeight.Bold),
                                        color = Color.White
                                    )
                                    Icon(Icons.Rounded.ExpandMore, contentDescription = null, tint = Color.White, modifier = Modifier.padding(start = 4.dp).size(16.dp))
                                }
                            }
                            
                            Spacer(Modifier.height(16.dp))

                            // Saldo Gigante
                            ModernMoneyText(
                                cents = currentAvailable,
                                hideBalances = localHideBalances,
                                color = Color.White,
                                integerFontSize = 56.sp, decimalFontSize = 32.sp, symbolFontSize = 32.sp
                            )
                            
                            Spacer(Modifier.height(8.dp))

                            // Dettagli IBAN Per Conto
                            Surface(
                                shape = RoundedCornerShape(16.dp),
                                color = Color.White.copy(alpha = 0.08f),
                                border = BorderStroke(1.dp, Color.White.copy(alpha = 0.15f)),
                                modifier = Modifier
                                    .clip(RoundedCornerShape(16.dp))
                                    .clickable {
                                        triggerHapticTick()
                                        if (currentIbanAccount != null) {
                                            showIbanDialog = true
                                        } else {
                                            showAccountSelector = true
                                        }
                                    }
                            ) {
                                Row(verticalAlignment = Alignment.CenterVertically, modifier = Modifier.padding(horizontal = 14.dp, vertical = 8.dp)) {
                                    Icon(Icons.Rounded.AccountBalance, null, tint = Color(0xFFF59E0B), modifier = Modifier.size(16.dp))
                                    Spacer(Modifier.width(8.dp))
                                    Text(
                                        text = if (currentIbanAccount != null) {
                                            if (savedIban.isNotBlank()) "${currentIbanAccount.name}: $savedIban"
                                            else "Tocca per inserire IBAN (${currentIbanAccount.name})"
                                        } else {
                                            "Seleziona un conto per l'IBAN"
                                        },
                                        style = MaterialTheme.typography.bodySmall.copy(fontWeight = FontWeight.Medium),
                                        color = Color.White
                                    )
                                }
                            }
                            
                            Spacer(Modifier.height(12.dp))
                            
                            Row(
                                verticalAlignment = Alignment.CenterVertically,
                                horizontalArrangement = Arrangement.Center
                            ) {
                                Text("Max Dispo: ", style = MaterialTheme.typography.labelMedium.copy(fontWeight = FontWeight.SemiBold), color = Color.White.copy(alpha = 0.7f))
                                ModernMoneyText(
                                    cents = currentAvailable + emergencyVisibile,
                                    hideBalances = localHideBalances,
                                    color = Color.White,
                                    integerFontSize = 14.sp,
                                    decimalFontSize = 11.sp,
                                    symbolFontSize = 11.sp
                                )
                            }
                        }
                    }

                    // ðŸš€ STICKY HEADER REVOLUT: ACTION BUTTONS (Sfondo scuro compatto e Saldo Fissato in Scroll)
                    stickyHeader {
                        Surface(
                            modifier = Modifier.fillMaxWidth(),
                            color = if (isCollapsed) {
                                if (hasCustomBg) Color.Black.copy(alpha = 0.40f) else Color(0xFF0F172A).copy(alpha = 0.96f)
                            } else Color.Transparent,
                            shadowElevation = if (isCollapsed && !hasCustomBg) 8.dp else 0.dp
                        ) {
                            Column(
                                modifier = Modifier
                                    .fillMaxWidth()
                                    .padding(horizontal = 16.dp, vertical = 8.dp)
                            ) {
                                
                                AnimatedVisibility(visible = isCollapsed) {
                                    Row(
                                        modifier = Modifier
                                            .fillMaxWidth()
                                            .padding(bottom = 12.dp, start = 4.dp, end = 4.dp),
                                        horizontalArrangement = Arrangement.SpaceBetween,
                                        verticalAlignment = Alignment.CenterVertically
                                    ) {
                                        // Saldo Disponibile compatto fisso in alto durante lo scroll
                                        Column {
                                            Text(
                                                text = "DISPONIBILE",
                                                style = MaterialTheme.typography.labelSmall.copy(fontSize = 10.sp, letterSpacing = 1.sp, fontWeight = FontWeight.ExtraBold),
                                                color = Color(0xFFA0A0A0)
                                            )
                                            ModernMoneyText(
                                                cents = currentAvailable,
                                                hideBalances = localHideBalances,
                                                color = Color.White,
                                                integerFontSize = 20.sp,
                                                decimalFontSize = 13.sp,
                                                symbolFontSize = 13.sp
                                            )
                                        }

                                        // Pillola Selettore Conto
                                        Surface(
                                            shape = RoundedCornerShape(50),
                                            color = Color.White.copy(alpha = 0.15f),
                                            border = BorderStroke(1.dp, Color.White.copy(alpha = 0.25f)),
                                            modifier = Modifier.clickable {
                                                triggerHapticTick()
                                                showAccountSelector = true
                                            }
                                        ) {
                                            Row(
                                                verticalAlignment = Alignment.CenterVertically,
                                                modifier = Modifier.padding(horizontal = 12.dp, vertical = 6.dp)
                                            ) {
                                                TxLogo(activeAccountLogoEmoji?.takeIf { it.isNotBlank() }, activeAccountLogoUri?.takeIf { it.isNotBlank() }, activeAccountName, Modifier.size(14.dp))
                                                Spacer(Modifier.width(6.dp))
                                                Text(
                                                    text = activeAccountName,
                                                    style = MaterialTheme.typography.labelMedium.copy(fontWeight = FontWeight.Bold),
                                                    color = Color.White
                                                )
                                                Icon(Icons.Rounded.ExpandMore, contentDescription = null, tint = Color.White, modifier = Modifier.padding(start = 2.dp).size(16.dp))
                                            }
                                        }
                                    }
                                }

                                Row(
                                    modifier = Modifier.fillMaxWidth(),
                                    horizontalArrangement = Arrangement.SpaceEvenly,
                                    verticalAlignment = Alignment.Top
                                ) {
                                    Column(horizontalAlignment = Alignment.CenterHorizontally, modifier = Modifier.clickable { onQuickAddActive("INCOME") }) {
                                        Surface(
                                            shape = CircleShape,
                                            color = if (isCollapsed && !hasCustomBg) Color(0xFF1E293B) else Color(0xFF10B981).copy(alpha = 0.20f),
                                            border = BorderStroke(1.dp, if (isCollapsed && !hasCustomBg) Color(0xFF10B981).copy(alpha = 0.6f) else Color(0xFF10B981).copy(alpha = 0.35f)),
                                            modifier = Modifier.size(48.dp)
                                        ) {
                                            Icon(Icons.Rounded.Add, contentDescription = "Aggiungi fondi", tint = Color(0xFF10B981), modifier = Modifier.padding(12.dp))
                                        }
                                        Spacer(Modifier.height(8.dp))
                                        Text("Aggiungi\nfondi", style = MaterialTheme.typography.labelSmall.copy(fontSize = 10.sp, fontWeight = FontWeight.Bold), color = Color.White, textAlign = TextAlign.Center)
                                    }
                                    Column(horizontalAlignment = Alignment.CenterHorizontally, modifier = Modifier.clickable { onQuickAddActive("EXPENSE") }) {
                                        Surface(
                                            shape = CircleShape,
                                            color = if (isCollapsed && !hasCustomBg) Color(0xFF1E293B) else Color(0xFFF87171).copy(alpha = 0.20f),
                                            border = BorderStroke(1.dp, if (isCollapsed && !hasCustomBg) Color(0xFFF87171).copy(alpha = 0.6f) else Color(0xFFF87171).copy(alpha = 0.35f)),
                                            modifier = Modifier.size(48.dp)
                                        ) {
                                            Icon(Icons.Rounded.Remove, contentDescription = "Rimuovi fondi", tint = Color(0xFFF87171), modifier = Modifier.padding(12.dp))
                                        }
                                        Spacer(Modifier.height(8.dp))
                                        Text("Rimuovi\nfondi", style = MaterialTheme.typography.labelSmall.copy(fontSize = 10.sp, fontWeight = FontWeight.Bold), color = Color.White, textAlign = TextAlign.Center)
                                    }
                                    Column(horizontalAlignment = Alignment.CenterHorizontally, modifier = Modifier.clickable { onQuickAddActive("TRANSFER") }) {
                                        Surface(
                                            shape = CircleShape,
                                            color = if (isCollapsed && !hasCustomBg) Color(0xFF1E293B) else Color(0xFF60A5FA).copy(alpha = 0.20f),
                                            border = BorderStroke(1.dp, if (isCollapsed && !hasCustomBg) Color(0xFF60A5FA).copy(alpha = 0.6f) else Color(0xFF60A5FA).copy(alpha = 0.35f)),
                                            modifier = Modifier.size(48.dp)
                                        ) {
                                            Icon(Icons.Rounded.SwapHoriz, contentDescription = "Sposta fondi", tint = Color(0xFF60A5FA), modifier = Modifier.padding(12.dp))
                                        }
                                        Spacer(Modifier.height(8.dp))
                                        Text("Sposta\nfondi", style = MaterialTheme.typography.labelSmall.copy(fontSize = 10.sp, fontWeight = FontWeight.Bold), color = Color.White, textAlign = TextAlign.Center)
                                    }
                                    Column(horizontalAlignment = Alignment.CenterHorizontally, modifier = Modifier.clickable { showIbanDialog = true }) {
                                        Surface(
                                            shape = CircleShape,
                                            color = if (isCollapsed && !hasCustomBg) Color(0xFF1E293B) else Color(0xFFF59E0B).copy(alpha = 0.20f),
                                            border = BorderStroke(1.dp, if (isCollapsed && !hasCustomBg) Color(0xFFF59E0B).copy(alpha = 0.6f) else Color(0xFFF59E0B).copy(alpha = 0.35f)),
                                            modifier = Modifier.size(48.dp)
                                        ) {
                                            Icon(Icons.Rounded.AccountBalance, contentDescription = "Coordinate", tint = Color(0xFFF59E0B), modifier = Modifier.padding(12.dp))
                                        }
                                        Spacer(Modifier.height(8.dp))
                                        Text("Coordinate\nIBAN", style = MaterialTheme.typography.labelSmall.copy(fontSize = 10.sp, fontWeight = FontWeight.Bold), color = Color.White, textAlign = TextAlign.Center)
                                    }
                                }
                            }
                        }
                    }

                    // ðŸš€ AVVISI E BENTO BOX WIDGETS
                    item {
                        Column(modifier = Modifier.fillMaxWidth().padding(horizontal = 16.dp)) {
                            // Variabile Calcolo Saldo Banca
                            val saldoVisibileBanca = remember(currentAccounting, totalSogni, totalPac, totalSalvadanai, cicliPositivi, emergencyBalanceCents) {
                                currentAccounting + totalSogni + totalPac + totalSalvadanai + cicliPositivi + emergencyBalanceCents
                            }

                            // AVVISI DI ALLARME
                            if (scudoIntervento > 0L && !hideBalances) {
                                Spacer(Modifier.height(12.dp))
                                Surface(shape = RoundedCornerShape(12.dp), color = MaterialTheme.colorScheme.error.copy(alpha=0.15f), modifier = Modifier.padding(bottom = 12.dp)) {
                                    Row(verticalAlignment = Alignment.CenterVertically, modifier = Modifier.fillMaxWidth().padding(12.dp)) {
                                        Icon(Icons.Rounded.WarningAmber, null, tint = MaterialTheme.colorScheme.error, modifier = Modifier.size(16.dp))
                                        Spacer(Modifier.width(8.dp))
                                        Text("Fondo emergenza: copre ${formatEuroFromCents(scudoIntervento, false)}", style = MaterialTheme.typography.labelSmall.copy(fontWeight = FontWeight.Bold), color = MaterialTheme.colorScheme.error)
                                    }
                                }
                            } else if (isIntaccandoScorta && currentAvailable > 0L && !hideBalances) {
                                Spacer(Modifier.height(12.dp))
                                Surface(shape = RoundedCornerShape(12.dp), color = Color(0xFFF59E0B).copy(alpha=0.15f), modifier = Modifier.padding(bottom = 12.dp)) {
                                    Row(verticalAlignment = Alignment.CenterVertically, modifier = Modifier.fillMaxWidth().padding(12.dp)) {
                                        Icon(Icons.Rounded.WarningAmber, null, tint = Color(0xFFF59E0B), modifier = Modifier.size(16.dp))
                                        Spacer(Modifier.width(8.dp))
                                        Text("Stai usando la scorta per ${formatEuroFromCents(scortaUsata, false)}", style = MaterialTheme.typography.labelSmall.copy(fontWeight = FontWeight.Bold), color = Color(0xFFF59E0B))
                                    }
                                }
                            }

                            Spacer(Modifier.height(8.dp))

                            // BENTO BOX GRID: 2 COLONNE
                            Row(modifier = Modifier.fillMaxWidth(), horizontalArrangement = Arrangement.spacedBy(12.dp)) {
                                // BLOCCO BANCA E SCUDO
                                Surface(
                                    modifier = Modifier.weight(1f),
                                    shape = RoundedCornerShape(20.dp),
                                    color = Color.White.copy(alpha = 0.08f),
                                    border = BorderStroke(1.dp, Color.White.copy(alpha = 0.15f))
                                ) {
                                    Column(modifier = Modifier.padding(16.dp)) {
                                        Row(verticalAlignment = Alignment.CenterVertically) {
                                            Icon(Icons.Rounded.AccountBalance, null, tint = Color.White.copy(alpha = 0.7f), modifier = Modifier.size(14.dp))
                                            Spacer(Modifier.width(6.dp))
                                            Text("In Banca", style = MaterialTheme.typography.labelSmall.copy(fontWeight = FontWeight.Bold), color = Color.White.copy(alpha = 0.7f))
                                        }
                                        Spacer(Modifier.height(4.dp))
                                        ModernMoneyText(cents = saldoVisibileBanca, hideBalances = hideBalances, color = Color.White, integerFontSize = 16.sp, decimalFontSize = 12.sp, symbolFontSize = 12.sp)
                                        
                                        Spacer(Modifier.height(12.dp))
                                        Row(verticalAlignment = Alignment.CenterVertically, modifier = Modifier.clip(RoundedCornerShape(6.dp)).clickable { showEmergencySheet = true }) {
                                            Icon(Icons.Rounded.Shield, null, tint = Color(0xFF60A5FA), modifier = Modifier.size(12.dp))
                                            Spacer(Modifier.width(6.dp))
                                            Text("Scudo", style = MaterialTheme.typography.labelSmall.copy(fontSize = 10.sp), color = Color(0xFF60A5FA))
                                            Spacer(Modifier.weight(1f))
                                            ModernMoneyText(cents = emergencyVisibile, hideBalances = hideBalances, color = Color(0xFF60A5FA), integerFontSize = 10.sp, decimalFontSize = 10.sp, symbolFontSize = 10.sp)
                                        }
                                    }
                                }

                                // BLOCCO IMPEGNI E SAFE TO SPEND
                                Surface(
                                    modifier = Modifier.weight(1f),
                                    shape = RoundedCornerShape(20.dp),
                                    color = Color.White.copy(alpha = 0.08f),
                                    border = BorderStroke(1.dp, Color.White.copy(alpha = 0.15f))
                                ) {
                                    Column(modifier = Modifier.padding(16.dp)) {
                                        Row(verticalAlignment = Alignment.CenterVertically) {
                                            Icon(Icons.Rounded.EventBusy, null, tint = Color.White.copy(alpha = 0.7f), modifier = Modifier.size(14.dp))
                                            Spacer(Modifier.width(6.dp))
                                            Text("Impegni", style = MaterialTheme.typography.labelSmall.copy(fontWeight = FontWeight.Bold), color = Color.White.copy(alpha = 0.7f))
                                        }
                                        Spacer(Modifier.height(4.dp))
                                        ModernMoneyText(cents = impegniVisivi, hideBalances = hideBalances, color = Color.White, integerFontSize = 16.sp, decimalFontSize = 12.sp, symbolFontSize = 12.sp)

                                        Spacer(Modifier.height(12.dp))
                                        Row(verticalAlignment = Alignment.CenterVertically) {
                                            Icon(Icons.Rounded.ShoppingCart, null, tint = Color(0xFF34D399), modifier = Modifier.size(12.dp))
                                            Spacer(Modifier.width(6.dp))
                                            Text("Safe/g", style = MaterialTheme.typography.labelSmall.copy(fontSize = 10.sp), color = Color(0xFF34D399))
                                            Spacer(Modifier.weight(1f))
                                            ModernMoneyText(cents = safeToSpendDailyCents, hideBalances = hideBalances, color = Color(0xFF34D399), integerFontSize = 10.sp, decimalFontSize = 10.sp, symbolFontSize = 10.sp)
                                        }
                                    }
                                }
                            }
                        }
                    }

                    item {
                        Column(modifier = Modifier.fillMaxWidth().padding(horizontal = 16.dp)) {
                            Spacer(Modifier.height(8.dp))

                            Surface(
                                modifier = Modifier
                                    .fillMaxWidth()
                                    .clickable { showAccantonatiPopup = true },
                                shape = RoundedCornerShape(16.dp),
                                color = Color.White.copy(alpha = 0.08f),
                                border = BorderStroke(1.dp, Color.White.copy(alpha = 0.15f))
                            ) {
                                Row(
                                    modifier = Modifier.fillMaxWidth().padding(16.dp),
                                    verticalAlignment = Alignment.CenterVertically
                                ) {
                                    Surface(
                                        shape = CircleShape,
                                        color = Color(0xFFF59E0B).copy(alpha = 0.15f),
                                        modifier = Modifier.size(40.dp)
                                    ) {
                                        Icon(Icons.Rounded.Lock, contentDescription = null, tint = Color(0xFFF59E0B), modifier = Modifier.padding(10.dp))
                                    }
                                    Spacer(Modifier.width(16.dp))
                                    Column(modifier = Modifier.weight(1f)) {
                                        Text("Liquidità  Impegnata", style = MaterialTheme.typography.titleMedium.copy(fontWeight = FontWeight.Bold), color = Color.White)
                                        Text("Tocca per i dettagli", style = MaterialTheme.typography.bodySmall, color = Color(0xFFA0A0A0))
                                    }
                                    ModernMoneyText(
                                        cents = totalAccantonato,
                                        hideBalances = hideBalances,
                                        color = Color(0xFFF59E0B),
                                        integerFontSize = 16.sp, decimalFontSize = 12.sp, symbolFontSize = 12.sp
                                    )
                                }
                            }

                            Spacer(Modifier.height(16.dp))

                            Surface(
                                modifier = Modifier
                                    .fillMaxWidth()
                                    .padding(bottom = 24.dp)
                                    .clickable { onOpenDebtManager() },
                                shape = RoundedCornerShape(16.dp),
                                color = Color.White.copy(alpha = 0.08f),
                                border = BorderStroke(1.dp, Color.White.copy(alpha = 0.15f))
                            ) {
                                Row(modifier = Modifier.padding(16.dp), verticalAlignment = Alignment.CenterVertically) {
                                    Surface(shape = CircleShape, color = Color.White.copy(alpha = 0.1f), modifier = Modifier.size(40.dp)) {
                                        Icon(Icons.Rounded.PeopleAlt, contentDescription = null, tint = Color.White, modifier = Modifier.padding(8.dp))
                                    }
                                    Spacer(Modifier.width(16.dp))
                                    Column(modifier = Modifier.weight(1f)) {
                                        Text("Ti devo / Mi devi", style = MaterialTheme.typography.titleMedium.copy(fontWeight = FontWeight.Bold), color = Color.White)
                                        Text("Gestisci i debiti con gli amici", style = MaterialTheme.typography.bodySmall, color = Color.White.copy(alpha = 0.7f))
                                    }

                                    val isPositive = netDebtBalance > 0L
                                    val isNeutral = netDebtBalance == 0L
                                    val amountColor = if (isNeutral) Color.White.copy(alpha = 0.7f) else if (isPositive) Color(0xFF34D399) else MaterialTheme.colorScheme.error
                                    val sign = if (isPositive) "+" else if (isNeutral) "" else "-"

                                    if (isNeutral) {
                                        Text(
                                            text = if (hideBalances) "â€¢â€¢â€¢" else "Pari",
                                            style = MaterialTheme.typography.titleMedium.copy(fontWeight = FontWeight.Bold),
                                            color = amountColor
                                        )
                                    } else {
                                        ModernMoneyText(
                                            cents = if(netDebtBalance < 0L) -netDebtBalance else netDebtBalance,
                                            hideBalances = hideBalances,
                                            sign = sign,
                                            color = amountColor,
                                            integerFontSize = 16.sp, decimalFontSize = 12.sp, symbolFontSize = 12.sp
                                        )
                                    }
                                }
                            }

                            Spacer(Modifier.height(12.dp))
                            Text("Riepilogo Mensile Fissato", style = MaterialTheme.typography.titleLarge.copy(fontWeight = FontWeight.Bold), color = Color.White, modifier = Modifier.padding(bottom = 16.dp))

                            // ðŸš€ RICALCOLO BARRE SEGMENTATE E TOTALI (Ora super sicuro in KMP)
                            val cardRecurringExpenses = recurringItems.filter { !it.isDeleted && it.isEnabled && it.type != "INCOME" && (activeAccountId == null || it.accountId == activeAccountId) }
                            val totalRecurringExpensesForCard = cardRecurringExpenses.fold(0L) { acc, it -> acc + it.amountCents }
                            val baseUnpaidRecExp = cardRecurringExpenses.filter { it.nextEpochDay <= periodEndEpoch }.fold(0L) { acc, it -> acc + it.amountCents }
                            val futureRecExp = latest.filter { tx ->
                                !tx.isDeleted && tx.dateEpochDay > todayEpoch && tx.dateEpochDay <= periodEndEpoch && tx.type != "INCOME" &&
                                        (tx.merchantKey?.contains("[rec:") == true || tx.description?.contains("[rec:") == true) &&
                                        (activeAccountId == null || tx.accountId == activeAccountId || tx.fromAccountId == activeAccountId)
                            }.fold(0L) { acc, it -> acc + if(it.amountCents < 0L) -it.amountCents else it.amountCents }
                            val paidRecExp = (totalRecurringExpensesForCard - baseUnpaidRecExp - futureRecExp).coerceAtLeast(0L)

                            val recurringIncomes = recurringItems.filter { !it.isDeleted && it.isEnabled && it.type == "INCOME" && (activeAccountId == null || it.accountId == activeAccountId) }
                            val totalRecurringIncomes = recurringIncomes.fold(0L) { acc, it -> acc + it.amountCents }
                            val baseUnpaidRecInc = recurringIncomes.filter { it.nextEpochDay <= periodEndEpoch }.fold(0L) { acc, it -> acc + it.amountCents }
                            val futureRecInc = latest.filter { tx ->
                                !tx.isDeleted && tx.dateEpochDay > todayEpoch && tx.dateEpochDay <= periodEndEpoch && tx.type == "INCOME" &&
                                        (tx.merchantKey?.contains("[rec:") == true || tx.description?.contains("[rec:") == true) &&
                                        (activeAccountId == null || tx.accountId == activeAccountId || tx.toAccountId == activeAccountId)
                            }.fold(0L) { acc, it -> acc + if(it.amountCents < 0L) -it.amountCents else it.amountCents }
                            val paidRecInc = (totalRecurringIncomes - baseUnpaidRecInc - futureRecInc).coerceAtLeast(0L)

                            val totalFinancingFixed = financingItems.filter { !it.isDeleted && !it.isClosed && (activeAccountId == null || it.accountId == activeAccountId) }.fold(0L) { acc, it -> acc + it.installmentAmountCents + (it.commissionCents ?: 0L) }
                            val baseUnpaidFin = remember(stats.unpaidFinancingList, activeAccountId) {
                                stats.unpaidFinancingList.filter { activeAccountId == null || it.accountId == activeAccountId }.fold(0L) { acc, it -> acc + it.installmentAmountCents + (it.commissionCents ?: 0L) }
                            }
                            val futureFin = latest.filter { tx ->
                                !tx.isDeleted && tx.dateEpochDay > todayEpoch && tx.dateEpochDay <= periodEndEpoch &&
                                        (tx.merchantKey?.contains("[fin:") == true || tx.description?.contains("[fin:") == true) &&
                                        (activeAccountId == null || tx.accountId == activeAccountId || tx.fromAccountId == activeAccountId)
                            }.fold(0L) { acc, it -> acc + if(it.amountCents < 0L) -it.amountCents else it.amountCents }
                            val paidFin = (totalFinancingFixed - baseUnpaidFin - futureFin).coerceAtLeast(0L)

                            if (totalRecurringExpensesForCard > 0L) {
                                SegmentedProgressCardContent(
                                    title = "Uscite Fisse",
                                    icon = Icons.Rounded.EventBusy, // ðŸš€ Icona moderna e pulita
                                    iconTint = Color(0xFFF87171), // Rosso/Rosa come l'avanzamento
                                    paidCents = paidRecExp,
                                    programmedCents = futureRecExp,
                                    unpaidCents = baseUnpaidRecExp,
                                    totalCents = totalRecurringExpensesForCard,
                                    hideBalances = hideBalances,
                                    paidLabel = "Pagato",
                                    programmedLabel = "Programmato",
                                    unpaidLabel = "Da pagare",
                                    onClick = { showRecurringExpenseSheet = true }
                                )
                                Spacer(Modifier.height(16.dp))
                            }

                            if (totalRecurringIncomes > 0L) {
                                SegmentedProgressCardContent(
                                    title = "Entrate Fisse",
                                    icon = Icons.Rounded.AccountBalanceWallet, // ðŸš€ Icona portafoglio
                                    iconTint = Color(0xFF34D399), // Verde acceso
                                    paidCents = paidRecInc,
                                    programmedCents = futureRecInc,
                                    unpaidCents = baseUnpaidRecInc,
                                    totalCents = totalRecurringIncomes,
                                    hideBalances = hideBalances,
                                    paidLabel = "Incassato",
                                    programmedLabel = "In arrivo",
                                    unpaidLabel = "Da incassare",
                                    onClick = { showRecurringIncomeSheet = true }
                                )
                                Spacer(Modifier.height(16.dp))
                            }

                            if (totalFinancingFixed > 0L || baseUnpaidFin > 0L || futureFin > 0L) {
                                SegmentedProgressCardContent(
                                    title = "Rate Debiti",
                                    icon = Icons.Rounded.CreditCard, // ðŸš€ Carta di credito per debiti/rate
                                    iconTint = Color(0xFF60A5FA), // Azzurro/Blu 
                                    paidCents = paidFin,
                                    programmedCents = futureFin,
                                    unpaidCents = baseUnpaidFin,
                                    totalCents = totalFinancingFixed,
                                    hideBalances = hideBalances,
                                    paidLabel = "Saldato",
                                    programmedLabel = "Programmato",
                                    unpaidLabel = "Da saldare",
                                    onClick = { showFinancingSheet = true }
                                )
                                Spacer(Modifier.height(32.dp))
                            }

                            if (favorites.isNotEmpty()) {
                                Row(modifier = Modifier.fillMaxWidth(), horizontalArrangement = Arrangement.SpaceBetween, verticalAlignment = Alignment.CenterVertically) {
                                    Text("Movimenti rapidi", style = MaterialTheme.typography.titleLarge.copy(fontWeight = FontWeight.Bold), color = Color.White, modifier = Modifier.padding(bottom = 16.dp))
                                    if (isEditFavoritesMode) { TextButton(onClick = { isEditFavoritesMode = false }) { Text("FINE", style = MaterialTheme.typography.labelSmall.copy(fontWeight = FontWeight.Bold), color = brandPrimary) } }
                                }

                                Row(modifier = Modifier.fillMaxWidth().horizontalScroll(rememberScrollState()), horizontalArrangement = Arrangement.spacedBy(24.dp)) {
                                    favorites.forEach { fav ->
                                        Box {
                                            Column(horizontalAlignment = Alignment.CenterHorizontally, modifier = Modifier.width(72.dp).combinedClickable(onClick = { if (!isEditFavoritesMode) onApplyFavorite(fav) }, onLongClick = { isEditFavoritesMode = true }, interactionSource = remember { MutableInteractionSource() }, indication = null)) {
                                                Surface(modifier = Modifier.size(48.dp), shape = CircleShape, color = Color.White.copy(alpha = 0.1f)) {
                                                    Box(contentAlignment = Alignment.Center) { TxLogo(fav.logoEmoji?.takeIf { it.isNotBlank() }, fav.logoUri?.takeIf { it.isNotBlank() }, fav.description ?: "R", Modifier.size(24.dp)) }
                                                }
                                                Spacer(Modifier.height(8.dp))
                                                Text((fav.description ?: "Rapido"), style = MaterialTheme.typography.bodySmall, color = Color.White, maxLines = 1, overflow = TextOverflow.Ellipsis)
                                            }
                                            if (isEditFavoritesMode) {
                                                Surface(modifier = Modifier.size(22.dp).align(Alignment.TopEnd).offset(x = 2.dp, y = (-2).dp).clickable { favoriteToRemove = fav }, shape = CircleShape, color = MaterialTheme.colorScheme.error) {
                                                    Icon(Icons.Rounded.Remove, contentDescription = "Rimuovi", tint = Color.White, modifier = Modifier.padding(2.dp))
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }

                    item {
                        Spacer(modifier = Modifier.height(500.dp))
                    }
                }
            }

            if (activeBreakdownType != null) {
                val (title, listDati) = when (activeBreakdownType) {
                    "sogni" -> "I Miei Sogni" to activeSogniList
                    "pac" -> "Smart PAC" to activePacList
                    "salvadanai" -> "Salvadanai Virtuali" to activeSalvadanaiList
                    "scadenze" -> "Scadenze Mese" to activeScadenzeMeseList
                    "cartelle" -> "Cartelle Esattoriali / Tasse" to activeCartelleList
                    "cicli" -> "Cicli Mensili" to activeSinkingFundsList
                    "programmati" -> "Movimenti Programmati" to programmatiBreakdown
                    "arrivo" -> "Movimenti in Arrivo (Già  generati)" to movimentiInArrivoBreakdown
                    else -> "" to emptyList<Pair<String, Long>>()
                }

                HomeBreakdownDialog(title = title, itemsList = listDati, hideBalances = hideBalances) {
                    activeBreakdownType = null
                }
            }
        }
    }

    // ðŸš€ POPUP PIN DI SICUREZZA
    if (showPinDialog) {
        AlertDialog(
            onDismissRequest = {
                showPinDialog = false
                pinInput = ""
                pinError = ""
            },
            shape = RoundedCornerShape(28.dp),
            containerColor = Color.White.copy(alpha = 0.12f),
            title = {
                Row(verticalAlignment = Alignment.CenterVertically) {
                    Icon(
                        Icons.Default.Lock,
                        contentDescription = null,
                        tint = Color(0xFF60A5FA),
                        modifier = Modifier.size(24.dp)
                    )
                    Spacer(Modifier.width(8.dp))
                    Text(
                        text = when (pinFlowMode) {
                            "ENTER" -> "Sblocca Vault"
                            "SETUP1" -> "Crea Codice"
                            "SETUP2" -> "Conferma Codice"
                            else -> "Sicurezza Vault"
                        },
                        style = MaterialTheme.typography.titleMedium.copy(fontWeight = FontWeight.Bold),
                        color = Color.White
                    )
                }
            },
            text = {
                Column {
                    Text(
                        text = when (pinFlowMode) {
                            "ENTER" -> "Inserisci il PIN per accedere."
                            "SETUP1" -> "Scegli un nuovo PIN di 4 cifre."
                            "SETUP2" -> "Reinserisci per confermare."
                            else -> ""
                        },
                        style = MaterialTheme.typography.bodySmall,
                        color = Color(0xFFA0A0A0)
                    )
                    Spacer(Modifier.height(16.dp))
                    OutlinedTextField(
                        value = pinInput,
                        onValueChange = {
                            if (it.length <= 4 && it.all { c -> c.isDigit() }) {
                                pinInput = it
                                pinError = ""
                                if (it.length == 4) {
                                    when (pinFlowMode) {
                                        "ENTER" -> {
                                            if (it == savedPin || (savedPin.isEmpty() && it == "0000")) {
                                                isVaultUnlocked = true
                                                showPinDialog = false
                                                pinInput = ""
                                                scope.launch { snackbarHostState.showSnackbar("Vault Sbloccato ðŸ”“", duration = SnackbarDuration.Short) }
                                            } else {
                                                pinError = "Codice errato."
                                                pinInput = ""
                                                haptic.performHapticFeedback(HapticFeedbackType.LongPress)
                                            }
                                        }
                                        "SETUP1" -> {
                                            tempPin = it
                                            pinInput = ""
                                            pinFlowMode = "SETUP2"
                                        }
                                        "SETUP2" -> {
                                            if (it == tempPin) {
                                                settings.putString("vault_pin", it)
                                                savedPin = it
                                                isVaultUnlocked = true
                                                showPinDialog = false
                                                pinInput = ""
                                                scope.launch {
                                                    com.example.monetix.db.FirestoreHelper().salvaPinVault(it)
                                                    snackbarHostState.showSnackbar("Vault configurato e sbloccato ðŸ”“", duration = SnackbarDuration.Short)
                                                }
                                            } else {
                                                pinError = "I PIN non corrispondono."
                                                pinInput = ""
                                                pinFlowMode = "SETUP1"
                                                haptic.performHapticFeedback(HapticFeedbackType.LongPress)
                                            }
                                        }
                                    }
                                }
                            }
                        },
                        visualTransformation = PasswordVisualTransformation(),
                        keyboardOptions = KeyboardOptions(keyboardType = KeyboardType.NumberPassword),
                        isError = pinError.isNotEmpty(),
                        singleLine = true,
                        shape = RoundedCornerShape(14.dp),
                        label = { Text("PIN (4 cifre)", color = Color(0xFFA0A0A0)) },
                        colors = OutlinedTextFieldDefaults.colors(
                            focusedTextColor = Color.White,
                            unfocusedTextColor = Color.White,
                            focusedContainerColor = Color.Black.copy(alpha = 0.35f),
                            unfocusedContainerColor = Color.Black.copy(alpha = 0.25f),
                            focusedBorderColor = Color(0xFF60A5FA),
                            unfocusedBorderColor = Color.White.copy(alpha = 0.2f),
                            focusedLabelColor = Color(0xFF60A5FA),
                            unfocusedLabelColor = Color(0xFFA0A0A0)
                        )
                    )
                    if (pinError.isNotEmpty()) {
                        Text(pinError, color = MaterialTheme.colorScheme.error, style = MaterialTheme.typography.labelSmall, modifier = Modifier.padding(top = 4.dp))
                    }
                }
            },
            confirmButton = {},
            dismissButton = {
                TextButton(onClick = {
                    showPinDialog = false
                    pinInput = ""
                    pinError = ""
                }) { Text("ANNULLA", color = Color.White, fontWeight = FontWeight.Bold) }
            }
        )
    }

    if (showAccountSelector) {
        val totalSumAllAccountsAvailable = remember(orderedVisibili, recurringItems, latest, stats) {
            orderedVisibili.sumOf { acc -> calculateAccountAvailable(acc.id) }
        }

        ModalBottomSheet(
            onDismissRequest = { showAccountSelector = false },
            sheetState = accountSheetState,
            containerColor = Color.White.copy(alpha = 0.12f),
            shape = RoundedCornerShape(topStart = 28.dp, topEnd = 28.dp)
        ) {
            Column(modifier = Modifier.fillMaxWidth().padding(horizontal = 24.dp, vertical = 16.dp).verticalScroll(rememberScrollState())) {

                Row(Modifier.fillMaxWidth().padding(bottom = 16.dp), horizontalArrangement = Arrangement.SpaceBetween) {
                    Column {
                        Text("SALDO DISPONIBILE", style = MaterialTheme.typography.labelSmall, color = Color(0xFFA0A0A0))
                        ModernMoneyText(cents = totalSumAllAccountsAvailable, hideBalances = hideBalances, color = Color.White, integerFontSize = 16.sp, decimalFontSize = 12.sp, symbolFontSize = 12.sp)
                    }
                    Column(horizontalAlignment = Alignment.End) {
                        Text("FINE CICLO", style = MaterialTheme.typography.labelSmall, color = Color(0xFFA0A0A0))
                        Text("${accountingPeriodEnd.dayOfMonth}/${accountingPeriodEnd.monthNumber}", style = MaterialTheme.typography.titleMedium.copy(fontWeight = FontWeight.Bold), color = Color.White)
                    }
                }
                HorizontalDivider(color = Color.White.copy(alpha = 0.1f))
                Spacer(Modifier.height(8.dp))

                Row(modifier = Modifier.fillMaxWidth(), horizontalArrangement = Arrangement.SpaceBetween, verticalAlignment = Alignment.CenterVertically) {
                    Text("I tuoi conti", style = MaterialTheme.typography.titleLarge.copy(fontWeight = FontWeight.Bold), color = Color.White)
                    TextButton(onClick = { onCreateAccount(); showAccountSelector = false }) {
                        Text("+ Nuovo", color = Color(0xFF60A5FA), fontWeight = FontWeight.Bold)
                    }
                }
                Spacer(Modifier.height(8.dp))

                Surface(
                    modifier = Modifier.fillMaxWidth().clickable { onSelectActive(""); showAccountSelector = false }.padding(vertical = 12.dp),
                    color = Color.Transparent
                ) {
                    Row(verticalAlignment = Alignment.CenterVertically) {
                        Surface(shape = CircleShape, color = Color(0xFF60A5FA).copy(alpha=0.15f), modifier = Modifier.size(40.dp)) {
                            Icon(Icons.Rounded.Language, null, tint = Color(0xFF60A5FA), modifier = Modifier.padding(8.dp))
                        }
                        Spacer(Modifier.width(12.dp))
                        Text("Vista Globale (Tutti i conti)", style = MaterialTheme.typography.bodyLarge.copy(fontWeight = FontWeight.SemiBold), color = Color.White)
                    }
                }
                HorizontalDivider(color = Color.White.copy(alpha = 0.1f))

                orderedVisibili.forEach { acc ->
                    val isAccHidden = hiddenAccountIds.contains(acc.id)
                    Column(modifier = Modifier.fillMaxWidth()) {
                        Row(
                            modifier = Modifier.fillMaxWidth().clickable { onSelectActive(acc.id); showAccountSelector = false }.padding(vertical = 12.dp),
                            verticalAlignment = Alignment.CenterVertically
                        ) {
                            TxLogo(acc.logoEmoji?.takeIf { it.isNotBlank() }, acc.logoUri?.takeIf { it.isNotBlank() }, acc.name, Modifier.size(40.dp))
                            Column(modifier = Modifier.weight(1f).padding(start = 12.dp)) {
                                Text(acc.name, style = MaterialTheme.typography.bodyLarge.copy(fontWeight = FontWeight.SemiBold), color = Color.White)
                                val accAvailable = calculateAccountAvailable(acc.id)
                                Row(verticalAlignment = Alignment.Bottom) {
                                    Text("Saldo disponibile: ", style = MaterialTheme.typography.labelSmall, color = Color(0xFFA0A0A0), modifier = Modifier.padding(bottom = 1.dp))
                                    ModernMoneyText(cents = accAvailable, hideBalances = hideBalances || isAccHidden, color = Color.White, integerFontSize = 12.sp, decimalFontSize = 10.sp, symbolFontSize = 10.sp)
                                }
                            }
                        }
                        Row(modifier = Modifier.fillMaxWidth().padding(bottom = 8.dp), horizontalArrangement = Arrangement.End, verticalAlignment = Alignment.CenterVertically) {
                            IconButton(onClick = { triggerHapticTick(); onToggleAccountHidden(acc.id) }, modifier = Modifier.size(32.dp)) { Icon(if (isAccHidden) Icons.Rounded.VisibilityOff else Icons.Rounded.Visibility, null, modifier = Modifier.size(18.dp), tint = if(isAccHidden) Color(0xFF60A5FA) else Color(0xFFA0A0A0)) }
                            IconButton(onClick = { triggerHapticTick(); accountToVault = acc; showAccountSelector = false }, modifier = Modifier.size(32.dp)) { Icon(Icons.Rounded.Lock, "Vault", modifier = Modifier.size(18.dp), tint = Color(0xFFA0A0A0)) }
                            IconButton(onClick = { triggerHapticTick(); accountToArchive = acc; showAccountSelector = false }, modifier = Modifier.size(32.dp)) { Icon(Icons.Rounded.Archive, "Archivia", modifier = Modifier.size(18.dp), tint = Color(0xFFA0A0A0)) }
                            IconButton(onClick = { triggerHapticTick(); accountToDelete = acc; showAccountSelector = false }, modifier = Modifier.size(32.dp)) { Icon(Icons.Rounded.DeleteOutline, "Elimina", modifier = Modifier.size(18.dp), tint = MaterialTheme.colorScheme.error) }
                            IconButton(onClick = { triggerHapticTick(); onEditAccount(acc); showAccountSelector = false }, modifier = Modifier.size(32.dp)) { Icon(Icons.Rounded.Edit, "Modifica", modifier = Modifier.size(18.dp), tint = Color.White) }
                            Spacer(Modifier.width(8.dp))
                            FilledTonalButton(
                                onClick = { triggerHapticTick(); onOpenMovementsListForAccount(acc.id); showAccountSelector = false },
                                contentPadding = PaddingValues(horizontal = 12.dp, vertical = 0.dp),
                                modifier = Modifier.height(32.dp),
                                colors = ButtonDefaults.filledTonalButtonColors(containerColor = Color.White.copy(alpha = 0.12f), contentColor = Color.White)
                            ) {
                                Text("Lista", fontSize = 12.sp, fontWeight = FontWeight.Bold)
                            }
                        }
                        HorizontalDivider(color = Color.White.copy(alpha = 0.1f))
                    }
                }

                if (listNascosti.isNotEmpty()) {
                    Spacer(Modifier.height(16.dp))
                    Row(
                        modifier = Modifier
                            .fillMaxWidth()
                            .padding(vertical = 8.dp)
                            .clickable {
                                com.example.monetix.utils.triggerHapticTick()
                                if (isVaultUnlocked) {
                                    hiddenExpanded = !hiddenExpanded
                                } else {
                                    showPinDialog = true
                                }
                            },
                        verticalAlignment = Alignment.CenterVertically
                    ) {
                        Icon(Icons.Rounded.Lock, contentDescription = null, tint = Color(0xFFF59E0B), modifier = Modifier.size(20.dp))
                        Spacer(Modifier.width(8.dp))
                        Text("Vault (Conti Nascosti)", style = MaterialTheme.typography.titleMedium.copy(fontWeight = FontWeight.Bold), color = Color(0xFFF59E0B), modifier = Modifier.weight(1f))
                        Icon(imageVector = if (hiddenExpanded && isVaultUnlocked) Icons.Rounded.ExpandLess else Icons.Rounded.ExpandMore, contentDescription = null, tint = Color(0xFFA0A0A0))
                    }
                    AnimatedVisibility(visible = hiddenExpanded && isVaultUnlocked) {
                        Column {
                            listNascosti.forEach { acc ->
                                Row(modifier = Modifier.fillMaxWidth().padding(vertical = 12.dp), verticalAlignment = Alignment.CenterVertically) {
                                    TxLogo(acc.logoEmoji?.takeIf { it.isNotBlank() }, acc.logoUri?.takeIf { it.isNotBlank() }, acc.name, Modifier.size(32.dp))
                                    Column(modifier = Modifier.weight(1f).padding(start = 12.dp)) {
                                        Text(acc.name, style = MaterialTheme.typography.bodyMedium.copy(fontWeight = FontWeight.SemiBold), color = Color.White)
                                        val accAvailable = calculateAccountAvailable(acc.id)
                                        Row(verticalAlignment = Alignment.Bottom) {
                                            Text("Saldo disponibile: ", style = MaterialTheme.typography.labelSmall, color = Color(0xFFA0A0A0), modifier = Modifier.padding(bottom = 1.dp))
                                            ModernMoneyText(cents = accAvailable, hideBalances = hideBalances, color = Color.White, integerFontSize = 12.sp, decimalFontSize = 10.sp, symbolFontSize = 10.sp)
                                        }
                                    }
                                    IconButton(onClick = { com.example.monetix.utils.triggerHapticTick(); accountToUnvault = acc; showAccountSelector = false }) { Icon(Icons.Rounded.Visibility, contentDescription = "Sblocca", tint = Color(0xFF60A5FA)) }
                                }
                                HorizontalDivider(color = Color.White.copy(alpha = 0.1f))
                            }
                        }
                    }
                }

                if (listArchiviati.isNotEmpty()) {
                    Spacer(Modifier.height(8.dp))
                    Row(modifier = Modifier.fillMaxWidth().padding(vertical = 8.dp).clickable { triggerHapticTick(); archivedExpanded = !archivedExpanded }, verticalAlignment = Alignment.CenterVertically) {
                        Icon(Icons.Rounded.Archive, contentDescription = null, tint = Color(0xFFA0A0A0), modifier = Modifier.size(20.dp))
                        Spacer(Modifier.width(8.dp))
                        Text("Archivio", style = MaterialTheme.typography.titleMedium.copy(fontWeight = FontWeight.Bold), color = Color.White, modifier = Modifier.weight(1f))
                        Icon(imageVector = if (archivedExpanded) Icons.Rounded.ExpandLess else Icons.Rounded.ExpandMore, contentDescription = null, tint = Color(0xFFA0A0A0))
                    }
                    AnimatedVisibility(visible = archivedExpanded) {
                        Column {
                            listArchiviati.forEach { acc ->
                                Row(modifier = Modifier.fillMaxWidth().padding(vertical = 12.dp), verticalAlignment = Alignment.CenterVertically) {
                                    TxLogo(acc.logoEmoji?.takeIf { it.isNotBlank() }, acc.logoUri?.takeIf { it.isNotBlank() }, acc.name, Modifier.size(32.dp))
                                    Text(acc.name, modifier = Modifier.weight(1f).padding(start = 12.dp), style = MaterialTheme.typography.bodyMedium.copy(fontWeight = FontWeight.SemiBold), color = Color.White)
                                    IconButton(onClick = { com.example.monetix.utils.triggerHapticTick(); accountToUnarchive = acc; showAccountSelector = false }) { Icon(Icons.Rounded.Restore, contentDescription = "Ripristina", tint = Color(0xFF10B981)) }
                                }
                                HorizontalDivider(color = Color.White.copy(alpha = 0.1f))
                            }
                        }
                    }
                }

                Spacer(Modifier.height(32.dp))
            }
        }
    }

    // ðŸš€ BOTTOM SHEET FONDO DI EMERGENZA
    if (showEmergencySheet) {
        ModalBottomSheet(
            onDismissRequest = { showEmergencySheet = false },
            containerColor = Color(0xFF1E1E1E).copy(alpha = 0.8f), // ðŸš€ Glassmorphism per il bottom sheet
            shape = RoundedCornerShape(topStart = 24.dp, topEnd = 24.dp)
        ) {
            Column(modifier = Modifier.fillMaxWidth().padding(horizontal = 24.dp, vertical = 16.dp)) {
                Row(modifier = Modifier.fillMaxWidth(), horizontalArrangement = Arrangement.SpaceBetween, verticalAlignment = Alignment.CenterVertically) {
                    Column {
                        Text("Fondo di Emergenza", style = MaterialTheme.typography.titleLarge.copy(fontWeight = FontWeight.Black), color = Color(0xFF60A5FA))
                        Text("La tua cassaforte per gli imprevisti.", style = MaterialTheme.typography.bodySmall, color = Color(0xFFA0A0A0))
                    }
                    IconButton(onClick = { showEmergencySettingsDialog = true }, modifier = Modifier.background(Color.White.copy(alpha = 0.1f), CircleShape)) {
                        Icon(Icons.Rounded.Settings, contentDescription = "Impostazioni Fondo", tint = Color.White)
                    }
                }

                Spacer(Modifier.height(24.dp))

                val emergencyProgress = if (emergencyTargetCents > 0L) (emergencyVisibile.toFloat() / emergencyTargetCents.toFloat()).coerceIn(0f, 1f) else 0f

                Row(modifier = Modifier.fillMaxWidth(), horizontalArrangement = Arrangement.SpaceBetween, verticalAlignment = Alignment.Bottom) {
                    ModernMoneyText(
                        cents = emergencyVisibile,
                        hideBalances = hideBalances,
                        color = Color(0xFF60A5FA),
                        integerFontSize = 28.sp, decimalFontSize = 16.sp, symbolFontSize = 16.sp
                    )
                    Text("Obiettivo: ${formatEuroFromCents(emergencyTargetCents, false)}", style = MaterialTheme.typography.labelSmall, color = Color(0xFFA0A0A0))
                }
                Spacer(Modifier.height(8.dp))
                LinearProgressIndicator(
                    progress = { emergencyProgress },
                    modifier = Modifier.fillMaxWidth().height(8.dp).clip(CircleShape),
                    color = Color(0xFF60A5FA),
                    trackColor = Color.White.copy(alpha = 0.10f)
                )

                Spacer(Modifier.height(24.dp))

                Row(modifier = Modifier.fillMaxWidth(), horizontalArrangement = Arrangement.spacedBy(12.dp)) {
                    Button(
                        onClick = { showEmergencySheet = false; emergencyActionType = "VERSA" },
                        modifier = Modifier.weight(1f).height(48.dp),
                        shape = RoundedCornerShape(12.dp),
                        colors = ButtonDefaults.buttonColors(containerColor = Color(0xFF10B981))
                    ) {
                        Icon(Icons.Rounded.ArrowDownward, null, modifier = Modifier.size(18.dp))
                        Spacer(Modifier.width(8.dp))
                        Text("VERSA", fontWeight = FontWeight.Bold)
                    }
                    Button(
                        onClick = { showEmergencySheet = false; emergencyActionType = "PRELEVA" },
                        modifier = Modifier.weight(1f).height(48.dp),
                        shape = RoundedCornerShape(12.dp),
                        colors = ButtonDefaults.buttonColors(containerColor = MaterialTheme.colorScheme.error)
                    ) {
                        Icon(Icons.Rounded.ArrowUpward, null, modifier = Modifier.size(18.dp))
                        Spacer(Modifier.width(8.dp))
                        Text("PRELEVA", fontWeight = FontWeight.Bold)
                    }
                }

                Spacer(Modifier.height(24.dp))
                Text("Movimenti del Fondo", style = MaterialTheme.typography.labelMedium.copy(fontWeight = FontWeight.Bold), color = Color(0xFFA0A0A0))
                Spacer(Modifier.height(8.dp))

                if (emergencyTxs.isEmpty()) {
                    Box(modifier = Modifier.fillMaxWidth().padding(32.dp), contentAlignment = Alignment.Center) {
                        Text("Nessun movimento nel fondo.", color = Color(0xFFA0A0A0))
                    }
                } else {
                    val sortedEmergencyTxs = remember(emergencyTxs) { emergencyTxs.sortedByDescending { it.dateEpochDay } }
                    LazyColumn(modifier = Modifier.fillMaxWidth().weight(1f, fill = false)) {
                        items(sortedEmergencyTxs, key = { "em_${it.id}" }) { tx ->
                            val isDeposit = (tx.type == "INCOME" && tx.accountId == "sys_emergency_fund") || (tx.type == "TRANSFER" && tx.toAccountId == "sys_emergency_fund")
                            val signUI = if (isDeposit) "+" else "-"
                            val colorUI = if (isDeposit) Color(0xFF10B981) else MaterialTheme.colorScheme.error
                            val displayName = tx.merchantKey?.takeIf { it.isNotBlank() } ?: tx.description?.takeIf { it.isNotBlank() } ?: if (isDeposit) "Versamento" else "Prelievo"

                            val d = LocalDate.fromEpochDays(tx.dateEpochDay.toInt())
                            val dateStr = "${d.dayOfMonth.toString().padStart(2, '0')} ${mesiShort[d.monthNumber - 1]}"

                            Row(
                                modifier = Modifier.fillMaxWidth().padding(vertical = 12.dp),
                                verticalAlignment = Alignment.CenterVertically,
                                horizontalArrangement = Arrangement.SpaceBetween
                            ) {
                                Box(modifier = Modifier.size(40.dp).background(colorUI.copy(alpha=0.1f), CircleShape), contentAlignment = Alignment.Center) {
                                    Icon(if(isDeposit) Icons.Rounded.ArrowDownward else Icons.Rounded.ArrowUpward, null, tint = colorUI, modifier = Modifier.size(20.dp))
                                }
                                Spacer(Modifier.width(12.dp))
                                Column(modifier = Modifier.weight(1f)) {
                                    Text(displayName, style = MaterialTheme.typography.bodyMedium.copy(fontWeight = FontWeight.Bold), color = Color.White, maxLines = 1, overflow = TextOverflow.Ellipsis)
                                    Text(dateStr, style = MaterialTheme.typography.labelSmall, color = Color(0xFFA0A0A0))
                                }
                                ModernMoneyText(
                                    cents = tx.amountCents,
                                    hideBalances = hideBalances,
                                    color = colorUI,
                                    sign = signUI,
                                    integerFontSize = 16.sp, decimalFontSize = 12.sp, symbolFontSize = 12.sp
                                )
                            }
                            HorizontalDivider(color = Color.White.copy(alpha = 0.05f))
                        }
                    }
                }
                Spacer(Modifier.height(16.dp))
            }
        }
    }

    // ðŸš€ POPUP RAPIDO VERSAMENTO/PRELIEVO SCUDO
    emergencyActionType?.let { action ->
        var amountText by remember { mutableStateOf("") }
        var reasonText by remember { mutableStateOf("") }
        val isDeposit = action == "VERSA"

        AlertDialog(
            onDismissRequest = { emergencyActionType = null },
            shape = RoundedCornerShape(28.dp),
            containerColor = Color.White.copy(alpha = 0.12f),
            title = {
                Row(verticalAlignment = Alignment.CenterVertically) {
                    Icon(
                        if (isDeposit) Icons.Rounded.ArrowDownward else Icons.Rounded.ArrowUpward,
                        contentDescription = null,
                        tint = if (isDeposit) Color(0xFF10B981) else MaterialTheme.colorScheme.error,
                        modifier = Modifier.size(24.dp)
                    )
                    Spacer(Modifier.width(8.dp))
                    Text(
                        if (isDeposit) "Versa nel Fondo" else "Preleva dal Fondo",
                        style = MaterialTheme.typography.titleMedium.copy(fontWeight = FontWeight.Bold),
                        color = Color.White
                    )
                }
            },
            text = {
                Column(verticalArrangement = Arrangement.spacedBy(16.dp)) {
                    Text(
                        text = if (isDeposit) "I soldi verranno spostati dal tuo conto principale allo Scudo, scomparendo dal saldo disponibile."
                        else "I soldi verranno riportati dallo Scudo al tuo conto principale.",
                        style = MaterialTheme.typography.bodySmall, color = Color(0xFFA0A0A0)
                    )

                    OutlinedTextField(
                        value = reasonText,
                        onValueChange = { reasonText = it },
                        label = { Text("Motivo (Opzionale)", color = Color(0xFFA0A0A0)) },
                        singleLine = true,
                        modifier = Modifier.fillMaxWidth(),
                        shape = RoundedCornerShape(12.dp),
                        colors = OutlinedTextFieldDefaults.colors(
                            focusedTextColor = Color.White,
                            unfocusedTextColor = Color.White,
                            focusedContainerColor = Color.Black.copy(alpha = 0.35f),
                            unfocusedContainerColor = Color.Black.copy(alpha = 0.25f),
                            focusedBorderColor = if (isDeposit) Color(0xFF10B981) else MaterialTheme.colorScheme.error,
                            unfocusedBorderColor = Color.White.copy(alpha = 0.20f),
                            focusedLabelColor = if (isDeposit) Color(0xFF10B981) else MaterialTheme.colorScheme.error,
                            unfocusedLabelColor = Color(0xFFA0A0A0)
                        )
                    )

                    OutlinedTextField(
                        value = amountText,
                        onValueChange = { if (it.all { c -> c.isDigit() || c == ',' || c == '.' }) amountText = it },
                        label = { Text("Importo (€)", color = Color(0xFFA0A0A0)) },
                        keyboardOptions = KeyboardOptions(keyboardType = KeyboardType.Decimal),
                        singleLine = true,
                        modifier = Modifier.fillMaxWidth(),
                        shape = RoundedCornerShape(12.dp),
                        colors = OutlinedTextFieldDefaults.colors(
                            focusedTextColor = Color.White,
                            unfocusedTextColor = Color.White,
                            focusedContainerColor = Color.Black.copy(alpha = 0.35f),
                            unfocusedContainerColor = Color.Black.copy(alpha = 0.25f),
                            focusedBorderColor = if (isDeposit) Color(0xFF10B981) else MaterialTheme.colorScheme.error,
                            unfocusedBorderColor = Color.White.copy(alpha = 0.20f),
                            focusedLabelColor = if (isDeposit) Color(0xFF10B981) else MaterialTheme.colorScheme.error,
                            unfocusedLabelColor = Color(0xFFA0A0A0)
                        )
                    )
                }
            },
            confirmButton = {
                Button(
                    onClick = {
                        val cents = (amountText.replace(",", ".").toDoubleOrNull()?.times(100))?.toLong() ?: 0L
                        if (cents > 0L) {
                            val nowMs = Clock.System.now().toEpochMilliseconds()
                            // Trova un conto reale per fare da controparte
                            val fallbackAccId = accounts.firstOrNull { !it.isDeleted && !it.isArchived && !it.isHidden }?.id ?: "default"
                            val realAccId = if (activeAccountId != null && !activeAccountId.startsWith("sys_")) activeAccountId else fallbackAccId

                            val subTx = TransactionEntity(
                                id = "tx_em_${nowMs}_${Random.nextInt(1000)}",
                                accountId = if (isDeposit) realAccId else "sys_emergency_fund",
                                toAccountId = if (isDeposit) "sys_emergency_fund" else realAccId,
                                fromAccountId = if (isDeposit) realAccId else "sys_emergency_fund",
                                amountCents = cents,
                                type = "TRANSFER",
                                dateEpochDay = todayEpoch,
                                categoryId = "default",
                                description = reasonText.trim().ifBlank { if (isDeposit) "Versamento Scudo" else "Prelievo Scudo" },
                                merchantKey = if (isDeposit) "Fondo di Emergenza" else "Fondo di Emergenza",
                                subcategoryText = "Scudo",
                                logoEmoji = "ðŸ›¡ï¸",
                                logoUri = null,
                                isHidden = false,
                                isDeleted = false,
                                reminderDays = null,
                                createdAtEpochMs = nowMs,
                                updatedAtEpochMs = nowMs
                            )
                            onSaveTransaction(subTx)
                            emergencyActionType = null

                            scope.launch { snackbarHostState.showSnackbar(if (isDeposit) "Scudo rinforzato! ðŸ›¡ï¸" else "Fondi prelevati dallo Scudo âš ï¸", duration = SnackbarDuration.Short) }
                        }
                    },
                    shape = RoundedCornerShape(14.dp),
                    colors = ButtonDefaults.buttonColors(containerColor = if (isDeposit) Color(0xFF10B981) else MaterialTheme.colorScheme.error, contentColor = Color.White)
                ) { Text("CONFERMA", fontWeight = FontWeight.Bold) }
            },
            dismissButton = {
                TextButton(onClick = { emergencyActionType = null }) { Text("ANNULLA", color = Color.White, fontWeight = FontWeight.Bold) }
            }
        )
    }

    if (showEmergencySettingsDialog) {
        var targetInput by remember { mutableStateOf((emergencyTargetCents / 100).toString()) }

        AlertDialog(
            onDismissRequest = { showEmergencySettingsDialog = false },
            shape = RoundedCornerShape(28.dp),
            containerColor = Color.White.copy(alpha = 0.12f),
            title = {
                Row(verticalAlignment = Alignment.CenterVertically) {
                    Icon(
                        Icons.Rounded.Settings,
                        contentDescription = null,
                        tint = Color(0xFF60A5FA),
                        modifier = Modifier.size(24.dp)
                    )
                    Spacer(Modifier.width(8.dp))
                    Text(
                        "Obiettivo Fondo",
                        style = MaterialTheme.typography.titleMedium.copy(fontWeight = FontWeight.Bold),
                        color = Color.White
                    )
                }
            },
            text = {
                Column(verticalArrangement = Arrangement.spacedBy(12.dp)) {
                    Text("Imposta il target del tuo fondo di emergenza (es. 3-6 mesi di spese fisse).", style = MaterialTheme.typography.bodySmall, color = Color(0xFFA0A0A0))
                    OutlinedTextField(
                        value = targetInput,
                        onValueChange = { if (it.all { c -> c.isDigit() }) targetInput = it },
                        label = { Text("Target (€)", color = Color(0xFFA0A0A0)) },
                        keyboardOptions = KeyboardOptions(keyboardType = KeyboardType.Number),
                        singleLine = true,
                        modifier = Modifier.fillMaxWidth(),
                        shape = RoundedCornerShape(12.dp),
                        colors = OutlinedTextFieldDefaults.colors(
                            focusedTextColor = Color.White,
                            unfocusedTextColor = Color.White,
                            focusedContainerColor = Color.Black.copy(alpha = 0.35f),
                            unfocusedContainerColor = Color.Black.copy(alpha = 0.25f),
                            focusedBorderColor = Color(0xFF60A5FA),
                            unfocusedBorderColor = Color.White.copy(alpha = 0.20f),
                            focusedLabelColor = Color(0xFF60A5FA),
                            unfocusedLabelColor = Color(0xFFA0A0A0)
                        )
                    )
                }
            },
            confirmButton = {
                Button(
                    onClick = {
                        val newTargetCents = (targetInput.toLongOrNull() ?: 0L) * 100L
                        onUpdateEmergencyTarget(newTargetCents)
                        showEmergencySettingsDialog = false
                    },
                    shape = RoundedCornerShape(14.dp),
                    colors = ButtonDefaults.buttonColors(containerColor = Color(0xFF60A5FA), contentColor = Color.White)
                ) { Text("SALVA", fontWeight = FontWeight.Bold) }
            },
            dismissButton = {
                TextButton(onClick = { showEmergencySettingsDialog = false }) { Text("ANNULLA", color = Color.White, fontWeight = FontWeight.Bold) }
            }
        )
    }

    if (showRecurringExpenseSheet) {
        val recurringSheetBlur by animateDpAsState(
            targetValue = if (recurringToPay != null || recurringToUndo != null) 12.dp else 0.dp,
            animationSpec = tween(durationMillis = 300),
            label = "recSheetBlur"
        )

        ModalBottomSheet(
            onDismissRequest = { showRecurringExpenseSheet = false },
            sheetState = recurringExpenseSheetState,
            containerColor = Color.White.copy(alpha = 0.12f),
            shape = RoundedCornerShape(topStart = 28.dp, topEnd = 28.dp)
        ) {
            Column(modifier = Modifier.fillMaxWidth().padding(horizontal = 24.dp, vertical = 16.dp).blur(recurringSheetBlur)) {
                Row(modifier = Modifier.fillMaxWidth(), horizontalArrangement = Arrangement.SpaceBetween, verticalAlignment = Alignment.CenterVertically) {
                    Text("Spese e Trasferimenti", style = MaterialTheme.typography.headlineSmall.copy(fontWeight = FontWeight.Bold), color = Color.White)
                    IconButton(onClick = { onOpenRecurring(); showRecurringExpenseSheet = false }) {
                        Icon(Icons.Rounded.Edit, contentDescription = "Modifica", tint = Color.White)
                    }
                }
                Spacer(Modifier.height(16.dp))

                val activeItems = recurringItems.filter { !it.isDeleted && it.isEnabled && it.type != "INCOME" && (activeAccountId == null || it.accountId == activeAccountId) }
                if (activeItems.isEmpty()) {
                    Text("Nessuna spesa fissa attiva su questo conto.", color = Color(0xFFA0A0A0))
                } else {
                    LazyColumn(modifier = Modifier.fillMaxWidth()) {
                        items(activeItems) { item ->
                            val pStartEpoch = payPeriodStart.toEpochDays().toLong()
                            val hasPaidThisMonth = latest.any { tx ->
                                !tx.isDeleted && tx.dateEpochDay >= pStartEpoch &&
                                        (tx.description?.contains("[rec:${item.id}]", ignoreCase = true) == true || tx.merchantKey?.contains("[rec:${item.id}]", ignoreCase = true) == true)
                            }
                            
                            val isUnpaid = item.nextEpochDay <= periodEndEpoch && !hasPaidThisMonth
                            val isTransfer = item.type == "TRANSFER" || item.toAccountId != null
                            val displayName = if (isTransfer) "${item.name} (Giroconto)" else item.name

                            val futureTx = latest.find { !it.isDeleted && (it.merchantKey?.contains("[rec:${item.id}]") == true || it.description?.contains("[rec:${item.id}]") == true) && it.dateEpochDay > todayEpoch }
                            val hasFuturePayment = futureTx != null

                            val statusText: String
                            val statusColor: Color

                            if (isUnpaid && !hasFuturePayment) {
                                val realNextDate = LocalDate.fromEpochDays(item.nextEpochDay.toInt())
                                val shiftedDate = getShiftedDueDate(item.dayOfMonth.toInt(), realNextDate.monthNumber, realNextDate.year)
                                val dateStr = "${shiftedDate.dayOfMonth.toString().padStart(2, '0')}/${shiftedDate.monthNumber.toString().padStart(2, '0')}"
                                statusText = "DA PAGARE (il $dateStr)"
                                statusColor = MaterialTheme.colorScheme.error
                            } else if (hasFuturePayment) {
                                val d = LocalDate.fromEpochDays(futureTx!!.dateEpochDay.toInt())
                                val dateStr = "${d.dayOfMonth.toString().padStart(2, '0')}/${d.monthNumber.toString().padStart(2, '0')}"
                                statusText = "PROGRAMMATO (il $dateStr)"
                                statusColor = Color(0xFFF59E0B)
                            } else {
                                // ðŸš€ CERCA LA TRANSAZIONE REALE PER DATA ESATTA DEL PAGAMENTO
                                val lastTx = latest.filter { !it.isDeleted && (it.merchantKey?.contains("[rec:${item.id}]") == true || it.description?.contains("[rec:${item.id}]") == true) && it.dateEpochDay <= todayEpoch }.maxByOrNull { it.dateEpochDay }
                                if (lastTx != null) {
                                    val d = LocalDate.fromEpochDays(lastTx.dateEpochDay.toInt())
                                    val dateStr = "${d.dayOfMonth.toString().padStart(2, '0')}/${d.monthNumber.toString().padStart(2, '0')}"
                                    statusText = "PAGATO (il $dateStr)"
                                } else {
                                    val realNextDate = LocalDate.fromEpochDays(item.nextEpochDay.toInt())
                                    var prevM = realNextDate.monthNumber - 1
                                    var prevY = realNextDate.year
                                    if (prevM < 1) { prevM = 12; prevY-- }
                                    val shiftedDate = getShiftedDueDate(item.dayOfMonth.toInt(), prevM, prevY)
                                    val dateStr = "${shiftedDate.dayOfMonth.toString().padStart(2, '0')}/${shiftedDate.monthNumber.toString().padStart(2, '0')}"
                                    statusText = "PAGATO (il $dateStr)"
                                }
                                statusColor = Color(0xFF10B981)
                            }

                            Row(
                                modifier = Modifier.fillMaxWidth().clickable {
                                    if (isUnpaid && !hasFuturePayment) recurringToPay = item else recurringToUndo = item
                                }.padding(vertical = 12.dp),
                                horizontalArrangement = Arrangement.SpaceBetween,
                                verticalAlignment = Alignment.CenterVertically
                            ) {
                                Column(modifier = Modifier.weight(1f).padding(end = 8.dp)) {
                                    Text(displayName, style = MaterialTheme.typography.bodyLarge.copy(fontWeight = FontWeight.SemiBold), color = Color.White, maxLines = 1, overflow = TextOverflow.Ellipsis)
                                    Text(text = statusText, style = MaterialTheme.typography.bodySmall.copy(fontWeight = FontWeight.SemiBold), color = statusColor)
                                }
                                ModernMoneyText(
                                    cents = item.amountCents,
                                    hideBalances = hideBalances,
                                    color = if (isUnpaid && !hasFuturePayment) Color.White else Color(0xFFA0A0A0),
                                    integerFontSize = 16.sp, decimalFontSize = 12.sp, symbolFontSize = 12.sp
                                )
                            }
                            HorizontalDivider(color = Color.White.copy(alpha = 0.1f))
                        }
                    }
                }
                Spacer(Modifier.height(32.dp))
            }
        }
    }

    if (showRecurringIncomeSheet) {
        val incomeSheetBlur by animateDpAsState(
            targetValue = if (recurringToPay != null || recurringToUndo != null) 12.dp else 0.dp,
            animationSpec = tween(durationMillis = 300),
            label = "incSheetBlur"
        )

        ModalBottomSheet(
            onDismissRequest = { showRecurringIncomeSheet = false },
            sheetState = recurringIncomeSheetState,
            containerColor = Color.White.copy(alpha = 0.12f),
            shape = RoundedCornerShape(topStart = 28.dp, topEnd = 28.dp)
        ) {
            Column(modifier = Modifier.fillMaxWidth().padding(horizontal = 24.dp, vertical = 16.dp).blur(incomeSheetBlur)) {
                Row(modifier = Modifier.fillMaxWidth(), horizontalArrangement = Arrangement.SpaceBetween, verticalAlignment = Alignment.CenterVertically) {
                    Text("Entrate Fisse", style = MaterialTheme.typography.headlineSmall.copy(fontWeight = FontWeight.Bold), color = Color(0xFF10B981))
                    IconButton(onClick = { onOpenRecurring(); showRecurringIncomeSheet = false }) {
                        Icon(Icons.Rounded.Edit, contentDescription = "Modifica", tint = Color(0xFF10B981))
                    }
                }
                Spacer(Modifier.height(16.dp))

                val activeItems = recurringItems.filter { !it.isDeleted && it.isEnabled && it.type == "INCOME" && (activeAccountId == null || it.accountId == activeAccountId) }
                if (activeItems.isEmpty()) {
                    Text("Nessuna entrata fissa attiva su questo conto.", color = Color(0xFFA0A0A0))
                } else {
                    LazyColumn(modifier = Modifier.fillMaxWidth()) {
                        items(activeItems) { item ->
                            val pStartEpoch = payPeriodStart.toEpochDays().toLong()
                            val hasPaidThisMonth = latest.any { tx ->
                                !tx.isDeleted && tx.dateEpochDay >= pStartEpoch &&
                                        (tx.description?.contains("[rec:${item.id}]", ignoreCase = true) == true || tx.merchantKey?.contains("[rec:${item.id}]", ignoreCase = true) == true)
                            }

                            val isUnpaid = item.nextEpochDay <= periodEndEpoch && !hasPaidThisMonth

                            val futureTx = latest.find { !it.isDeleted && (it.merchantKey?.contains("[rec:${item.id}]") == true || it.description?.contains("[rec:${item.id}]") == true) && it.dateEpochDay > todayEpoch }
                            val hasFuturePayment = futureTx != null

                            val statusText: String
                            val statusColor: Color

                            if (isUnpaid && !hasFuturePayment) {
                                val realNextDate = LocalDate.fromEpochDays(item.nextEpochDay.toInt())
                                val shiftedDate = getShiftedDueDate(item.dayOfMonth.toInt(), realNextDate.monthNumber, realNextDate.year)
                                val dateStr = "${shiftedDate.dayOfMonth.toString().padStart(2, '0')}/${shiftedDate.monthNumber.toString().padStart(2, '0')}"
                                statusText = "DA INCASSARE (il $dateStr)"
                                statusColor = MaterialTheme.colorScheme.error
                            } else if (hasFuturePayment) {
                                val d = LocalDate.fromEpochDays(futureTx!!.dateEpochDay.toInt())
                                val dateStr = "${d.dayOfMonth.toString().padStart(2, '0')}/${d.monthNumber.toString().padStart(2, '0')}"
                                statusText = "PROGRAMMATO (il $dateStr)"
                                statusColor = Color(0xFFF59E0B)
                            } else {
                                // ðŸš€ CERCA L'INCASSO REALE
                                val lastTx = latest.filter { !it.isDeleted && (it.merchantKey?.contains("[rec:${item.id}]") == true || it.description?.contains("[rec:${item.id}]") == true) && it.dateEpochDay <= todayEpoch }.maxByOrNull { it.dateEpochDay }
                                if (lastTx != null) {
                                    val d = LocalDate.fromEpochDays(lastTx.dateEpochDay.toInt())
                                    val dateStr = "${d.dayOfMonth.toString().padStart(2, '0')}/${d.monthNumber.toString().padStart(2, '0')}"
                                    statusText = "INCASSATO (il $dateStr)"
                                } else {
                                    val realNextDate = LocalDate.fromEpochDays(item.nextEpochDay.toInt())
                                    var prevM = realNextDate.monthNumber - 1
                                    var prevY = realNextDate.year
                                    if (prevM < 1) { prevM = 12; prevY-- }
                                    val shiftedDate = getShiftedDueDate(item.dayOfMonth.toInt(), prevM, prevY)
                                    val dateStr = "${shiftedDate.dayOfMonth.toString().padStart(2, '0')}/${shiftedDate.monthNumber.toString().padStart(2, '0')}"
                                    statusText = "INCASSATO (il $dateStr)"
                                }
                                statusColor = Color(0xFF10B981)
                            }

                            Row(
                                modifier = Modifier.fillMaxWidth().clickable {
                                    if (isUnpaid && !hasFuturePayment) recurringToPay = item else recurringToUndo = item
                                }.padding(vertical = 12.dp),
                                horizontalArrangement = Arrangement.SpaceBetween,
                                verticalAlignment = Alignment.CenterVertically
                            ) {
                                Column(modifier = Modifier.weight(1f).padding(end = 8.dp)) {
                                    Text(item.name ?: "Entrata", style = MaterialTheme.typography.bodyLarge.copy(fontWeight = FontWeight.SemiBold), color = Color.White, maxLines = 1, overflow = TextOverflow.Ellipsis)
                                    Text(text = statusText, style = MaterialTheme.typography.bodySmall.copy(fontWeight = FontWeight.SemiBold), color = statusColor)
                                }
                                ModernMoneyText(
                                    cents = item.amountCents,
                                    hideBalances = hideBalances,
                                    sign = "+",
                                    color = if (isUnpaid && !hasFuturePayment) Color.White else Color(0xFF10B981),
                                    integerFontSize = 16.sp, decimalFontSize = 12.sp, symbolFontSize = 12.sp
                                )
                            }
                            HorizontalDivider(color = Color.White.copy(alpha = 0.1f))
                        }
                    }
                }
                Spacer(Modifier.height(32.dp))
            }
        }
    }

    if (showFinancingSheet) {
        val financingSheetBlur by animateDpAsState(
            targetValue = if (financingToPay != null || financingToUndo != null) 12.dp else 0.dp,
            animationSpec = tween(durationMillis = 300),
            label = "finSheetBlur"
        )

        ModalBottomSheet(
            onDismissRequest = { showFinancingSheet = false },
            sheetState = financingSheetState,
            containerColor = Color.White.copy(alpha = 0.12f),
            shape = RoundedCornerShape(topStart = 28.dp, topEnd = 28.dp)
        ) {
            Column(modifier = Modifier.fillMaxWidth().padding(horizontal = 24.dp, vertical = 16.dp).blur(financingSheetBlur)) {
                Row(modifier = Modifier.fillMaxWidth(), horizontalArrangement = Arrangement.SpaceBetween, verticalAlignment = Alignment.CenterVertically) {
                    Text("Rate Debiti", style = MaterialTheme.typography.headlineSmall.copy(fontWeight = FontWeight.Bold), color = Color.White)
                    IconButton(onClick = { onOpenFinancings(); showFinancingSheet = false }) {
                        Icon(Icons.Rounded.Edit, contentDescription = "Modifica Rate", tint = Color.White)
                    }
                }
                Spacer(Modifier.height(16.dp))

                val activeItems = financingItems.filter { !it.isDeleted && !it.isClosed && (activeAccountId == null || it.accountId == activeAccountId) }
                if (activeItems.isEmpty()) {
                    Text("Nessuna rata attiva su questo conto.", color = Color(0xFFA0A0A0))
                } else {
                    LazyColumn(modifier = Modifier.fillMaxWidth()) {
                        items(activeItems) { item ->
                            val pStartEpoch = payPeriodStart.toEpochDays().toLong()
                            val hasPaidThisMonth = latest.any { tx ->
                                !tx.isDeleted && tx.dateEpochDay >= pStartEpoch &&
                                        (tx.description?.contains("[fin:${item.id}]", ignoreCase = true) == true || tx.merchantKey?.contains("[fin:${item.id}]", ignoreCase = true) == true)
                            }
                            
                            // Uniamo la logica di stats con il controllo mensile effettivo
                            val isUnpaid = stats.unpaidFinancingList.any { it.id == item.id } && !hasPaidThisMonth

                            val futureTx = latest.find { !it.isDeleted && (it.merchantKey?.contains("[fin:${item.id}]") == true || it.description?.contains("[fin:${item.id}]") == true) && it.dateEpochDay > todayEpoch }
                            val hasFuturePayment = futureTx != null

                            val statusText: String
                            val statusColor: Color

                            if (isUnpaid && !hasFuturePayment) {
                                var targetMonth = today.monthNumber
                                var targetYear = today.year
                                if (today.dayOfMonth >= payPeriodStart.dayOfMonth) {
                                    if (item.smartDueDay < payPeriodStart.dayOfMonth) {
                                        targetMonth++
                                        if (targetMonth > 12) { targetMonth = 1; targetYear++ }
                                    }
                                }
                                val shiftedDate = getShiftedDueDate(item.smartDueDay, targetMonth, targetYear)
                                val dateStr = "${shiftedDate.dayOfMonth.toString().padStart(2, '0')}/${shiftedDate.monthNumber.toString().padStart(2, '0')}"
                                statusText = "DA PAGARE (il $dateStr)"
                                statusColor = MaterialTheme.colorScheme.error
                            } else if (hasFuturePayment) {
                                val d = LocalDate.fromEpochDays(futureTx!!.dateEpochDay.toInt())
                                val dateStr = "${d.dayOfMonth.toString().padStart(2, '0')}/${d.monthNumber.toString().padStart(2, '0')}"
                                statusText = "PROGRAMMATO (il $dateStr)"
                                statusColor = Color(0xFFF59E0B)
                            } else {
                                // ðŸš€ CERCA IL PAGAMENTO DELLA RATA REALE
                                val lastTx = latest.filter { !it.isDeleted && (it.merchantKey?.contains("[fin:${item.id}]") == true || it.description?.contains("[fin:${item.id}]") == true) && it.dateEpochDay <= todayEpoch }.maxByOrNull { it.dateEpochDay }
                                if (lastTx != null) {
                                    val d = LocalDate.fromEpochDays(lastTx.dateEpochDay.toInt())
                                    val dateStr = "${d.dayOfMonth.toString().padStart(2, '0')}/${d.monthNumber.toString().padStart(2, '0')}"
                                    statusText = "PAGATO (il $dateStr)"
                                } else {
                                    statusText = "PAGATO"
                                }
                                statusColor = Color(0xFF10B981)
                            }

                            val totalInstallmentWithCommissions = item.installmentAmountCents + (item.commissionCents ?: 0L)

                            Row(
                                modifier = Modifier
                                    .fillMaxWidth()
                                    .clickable {
                                        if (isUnpaid && !hasFuturePayment) financingToPay = item else financingToUndo = item
                                    }
                                    .padding(vertical = 12.dp),
                                horizontalArrangement = Arrangement.SpaceBetween,
                                verticalAlignment = Alignment.CenterVertically
                            ) {
                                Column(modifier = Modifier.weight(1f).padding(end = 8.dp)) {
                                    Text(item.name ?: "Sconosciuto", style = MaterialTheme.typography.bodyLarge.copy(fontWeight = FontWeight.SemiBold), color = Color.White, maxLines = 1, overflow = TextOverflow.Ellipsis)
                                    Row(verticalAlignment = Alignment.CenterVertically) {
                                        Text(text = statusText, style = MaterialTheme.typography.bodySmall.copy(fontWeight = FontWeight.SemiBold), color = statusColor)
                                        if ((item.commissionCents ?: 0L) > 0L) { Text(text = " (+ comm.)", style = MaterialTheme.typography.bodySmall.copy(fontSize = 10.sp), color = Color(0xFFA0A0A0).copy(alpha = 0.6f)) }
                                    }
                                }
                                ModernMoneyText(
                                    cents = totalInstallmentWithCommissions,
                                    hideBalances = hideBalances,
                                    color = if (isUnpaid && !hasFuturePayment) Color.White else Color(0xFFA0A0A0),
                                    integerFontSize = 16.sp, decimalFontSize = 12.sp, symbolFontSize = 12.sp
                                )
                            }
                            HorizontalDivider(color = Color.White.copy(alpha = 0.1f))
                        }
                    }
                }
                Spacer(Modifier.height(32.dp))
            }
        }
    }

    // ==============================================================
    // ðŸš€ CENTRO NOTIFICHE
    // ==============================================================
    if (showNotificationsSheet) {
        ModalBottomSheet(
            onDismissRequest = { showNotificationsSheet = false },
            sheetState = notificationSheetState,
            containerColor = Color.White.copy(alpha = 0.12f),
            shape = RoundedCornerShape(topStart = 28.dp, topEnd = 28.dp)
        ) {
            Column(modifier = Modifier.fillMaxWidth().padding(bottom = 32.dp, start = 24.dp, end = 24.dp)) {

                Row(modifier = Modifier.fillMaxWidth(), horizontalArrangement = Arrangement.SpaceBetween, verticalAlignment = Alignment.CenterVertically) {
                    Text(
                        text = "Centro Notifiche",
                        style = MaterialTheme.typography.headlineSmall.copy(fontWeight = FontWeight.Bold),
                        color = Color.White
                    )
                    if (upcomingAlerts.isNotEmpty()) {
                        TextButton(onClick = {
                            upcomingAlerts.forEach { (_, tx) ->
                                val updatedTx = tx.copy(reminderDays = -1L, updatedAtEpochMs = Clock.System.now().toEpochMilliseconds())
                                onDismissTransaction(updatedTx)
                            }
                            dismissedNotificationIds = dismissedNotificationIds + upcomingAlerts.map { it.second.id }.toSet()
                            if (bankNotifs.isEmpty() && emergencyAlerts.isEmpty()) showNotificationsSheet = false
                        }) {
                            Text("Svuota scadenze", color = Color(0xFF60A5FA), fontWeight = FontWeight.Bold)
                        }
                    }
                }
                Spacer(Modifier.height(16.dp))

                if (totalNotifications == 0) {
                    Box(modifier = Modifier.fillMaxWidth().padding(vertical = 32.dp), contentAlignment = Alignment.Center) {
                        Text("Tutto tranquillo! Nessuna notifica.", color = Color(0xFFA0A0A0))
                    }
                } else {
                    LazyColumn(modifier = Modifier.fillMaxWidth().heightIn(max = 500.dp)) {

                        // 🚀 ALERT FONDO EMERGENZA (SEMPRE IN CIMA)
                        if (emergencyAlerts.isNotEmpty()) {
                            item {
                                Text("⚠️ FONDO EMERGENZA INTACCATO", style = MaterialTheme.typography.labelMedium.copy(fontWeight = FontWeight.Black), color = MaterialTheme.colorScheme.error, modifier = Modifier.padding(bottom = 8.dp, top = 8.dp))
                            }
                            items(emergencyAlerts, key = { "em_al_${it.id}" }) { tx ->
                                val absAmount = if (tx.amountCents < 0) -tx.amountCents else tx.amountCents
                                Row(
                                    modifier = Modifier.fillMaxWidth().padding(vertical = 12.dp),
                                    verticalAlignment = Alignment.CenterVertically
                                ) {
                                    Surface(
                                        modifier = Modifier.size(40.dp), shape = CircleShape, color = MaterialTheme.colorScheme.error.copy(alpha = 0.1f)
                                    ) {
                                        Icon(Icons.Rounded.WarningAmber, null, tint = MaterialTheme.colorScheme.error, modifier = Modifier.padding(8.dp))
                                    }

                                    Column(modifier = Modifier.weight(1f).padding(horizontal = 16.dp)) {
                                        Text(text = "Prelievo dal fondo", style = MaterialTheme.typography.bodyLarge.copy(fontWeight = FontWeight.SemiBold), color = Color.White, maxLines = 1, overflow = TextOverflow.Ellipsis)
                                        Text(text = "Ricorda di reintegrare", style = MaterialTheme.typography.bodySmall, color = MaterialTheme.colorScheme.error)
                                    }

                                    ModernMoneyText(cents = absAmount, hideBalances = hideBalances, integerFontSize = 16.sp, decimalFontSize = 12.sp, symbolFontSize = 12.sp, color = MaterialTheme.colorScheme.error, sign = "-")

                                    IconButton(onClick = {
                                        dismissedNotificationIds = dismissedNotificationIds + tx.id
                                        if (BankNotificationCatcher.pendingQueue.isEmpty() && upcomingAlerts.isEmpty() && emergencyAlerts.size == 1) showNotificationsSheet = false
                                    }) {
                                        Icon(Icons.Rounded.Check, contentDescription = "Segna letta", tint = Color(0xFFA0A0A0))
                                    }
                                }
                                HorizontalDivider(color = Color.White.copy(alpha = 0.1f))
                            }
                        }

                        if (bankNotifs.isNotEmpty()) {
                            item {
                                Text("DA CONFERMARE (Banca)", style = MaterialTheme.typography.labelMedium.copy(fontWeight = FontWeight.Black), color = Color(0xFF60A5FA), modifier = Modifier.padding(bottom = 8.dp, top = if(emergencyAlerts.isNotEmpty()) 16.dp else 8.dp))
                            }
                            items(bankNotifs) { notif ->
                                val isInc = notif.isIncome
                                val amountStr = notif.amount
                                val merch = notif.merchant
                                val color = if (isInc) Color(0xFF10B981) else MaterialTheme.colorScheme.error

                                Row(
                                    modifier = Modifier.fillMaxWidth().padding(vertical = 12.dp),
                                    verticalAlignment = Alignment.CenterVertically
                                ) {
                                    Surface(
                                        modifier = Modifier.size(40.dp), shape = CircleShape, color = color.copy(alpha = 0.1f)
                                    ) {
                                        Icon(if(isInc) Icons.Rounded.ArrowDownward else Icons.Rounded.ArrowUpward, null, tint = color, modifier = Modifier.padding(8.dp))
                                    }

                                    Column(modifier = Modifier.weight(1f).padding(horizontal = 12.dp)) {
                                        Text(text = merch, style = MaterialTheme.typography.bodyLarge.copy(fontWeight = FontWeight.SemiBold), color = Color.White, maxLines = 1, overflow = TextOverflow.Ellipsis)
                                        Text(text = "Rilevato: $amountStr €", style = MaterialTheme.typography.bodySmall, color = Color(0xFFA0A0A0))
                                    }

                                    Row(horizontalArrangement = Arrangement.End) {
                                        IconButton(onClick = {
                                            BankNotificationCatcher.removeNotificationById(notif.id)
                                            if (BankNotificationCatcher.pendingQueue.isEmpty() && upcomingAlerts.isEmpty() && emergencyAlerts.isEmpty()) showNotificationsSheet = false
                                        }, modifier = Modifier.size(36.dp)) {
                                            Icon(Icons.Rounded.Close, "Ignora", tint = Color(0xFFA0A0A0))
                                        }

                                        IconButton(onClick = {
                                            showNotificationsSheet = false
                                            BankNotificationCatcher.removeNotificationById(notif.id)
                                            onProcessBankData(amountStr, merch, isInc)
                                        }, modifier = Modifier.size(36.dp)) {
                                            Icon(Icons.Rounded.Check, "Registra", tint = Color(0xFF10B981))
                                        }
                                    }
                                }
                                HorizontalDivider(color = Color.White.copy(alpha = 0.1f))
                            }
                        }

                        if (upcomingAlerts.isNotEmpty()) {
                            item {
                                Text("SCADENZE PROGRAMMATE", style = MaterialTheme.typography.labelMedium.copy(fontWeight = FontWeight.Black), color = Color(0xFFA0A0A0), modifier = Modifier.padding(bottom = 8.dp, top = if(bankNotifs.isNotEmpty() || emergencyAlerts.isNotEmpty()) 16.dp else 8.dp))
                            }
                            items(upcomingAlerts, key = { it.second.id }) { (label, tx) ->
                                val color = if (label == "Oggi") MaterialTheme.colorScheme.error else Color(0xFF60A5FA)

                                Row(
                                    modifier = Modifier.fillMaxWidth().padding(vertical = 12.dp),
                                    verticalAlignment = Alignment.CenterVertically
                                ) {
                                    Surface(
                                        modifier = Modifier.size(40.dp), shape = CircleShape, color = color.copy(alpha = 0.1f)
                                    ) {
                                        Box(contentAlignment = Alignment.Center) {
                                            TxLogo(tx.logoEmoji?.takeIf { it.isNotBlank() }, tx.logoUri?.takeIf { it.isNotBlank() }, tx.merchantKey ?: "S", Modifier.size(20.dp))
                                        }
                                    }

                                    Column(modifier = Modifier.weight(1f).padding(horizontal = 16.dp)) {
                                        val rawName = tx.merchantKey ?: tx.description ?: "Operazione"
                                        val cleanName = rawName.replace(Regex("\\[.*?\\]"), "").trim().ifBlank { "Operazione" }
                                        Text(text = cleanName, style = MaterialTheme.typography.bodyLarge.copy(fontWeight = FontWeight.SemiBold), color = Color.White, maxLines = 1, overflow = TextOverflow.Ellipsis)
                                        Text(text = label, style = MaterialTheme.typography.bodySmall, color = color)
                                    }

                                    ModernMoneyText(cents = tx.amountCents, hideBalances = hideBalances, color = Color.White, integerFontSize = 16.sp, decimalFontSize = 12.sp, symbolFontSize = 12.sp)

                                    IconButton(onClick = {
                                        val updatedTx = tx.copy(reminderDays = -1L, updatedAtEpochMs = Clock.System.now().toEpochMilliseconds())
                                        onDismissTransaction(updatedTx)
                                        dismissedNotificationIds = dismissedNotificationIds + tx.id
                                    }) {
                                        Icon(Icons.Rounded.Check, contentDescription = "Segna letta", tint = Color(0xFFA0A0A0))
                                    }
                                }
                                HorizontalDivider(color = Color.White.copy(alpha = 0.1f))
                            }
                        }
                    }
                }
            }
        }
    }

    if (showSignOutPrompt) {
        AlertDialog(
            onDismissRequest = { showSignOutPrompt = false },
            shape = RoundedCornerShape(28.dp),
            containerColor = Color.White.copy(alpha = 0.12f),
            title = {
                Row(verticalAlignment = Alignment.CenterVertically) {
                    Icon(
                        Icons.Rounded.Logout,
                        contentDescription = null,
                        tint = Color(0xFFEF4444),
                        modifier = Modifier.size(24.dp)
                    )
                    Spacer(Modifier.width(8.dp))
                    Text(
                        "Conferma Uscita",
                        style = MaterialTheme.typography.titleMedium.copy(fontWeight = FontWeight.Bold),
                        color = Color.White
                    )
                }
            },
            text = {
                Text(
                    "Sei sicuro di voler disconnettere il tuo account da Monetix?",
                    style = MaterialTheme.typography.bodyMedium,
                    color = Color(0xFFA0A0A0)
                )
            },
            confirmButton = {
                Button(
                    onClick = {
                        showSignOutPrompt = false
                        scope.launch { Firebase.auth.signOut() }
                    },
                    shape = RoundedCornerShape(14.dp),
                    colors = ButtonDefaults.buttonColors(
                        containerColor = Color(0xFFEF4444),
                        contentColor = Color.White
                    )
                ) {
                    Text("ESCI", fontWeight = FontWeight.Bold)
                }
            },
            dismissButton = {
                TextButton(onClick = { showSignOutPrompt = false }) {
                    Text("ANNULLA", color = Color.White, fontWeight = FontWeight.Bold)
                }
            }
        )
    }

    if (showNukePrompt) {
        AlertDialog(
            onDismissRequest = { showNukePrompt = false },
            shape = RoundedCornerShape(28.dp),
            containerColor = Color.White.copy(alpha = 0.12f),
            title = {
                Row(verticalAlignment = Alignment.CenterVertically) {
                    Icon(Icons.Outlined.Warning, contentDescription = null, tint = Color(0xFFDC2626), modifier = Modifier.size(24.dp))
                    Spacer(Modifier.width(8.dp))
                    Text("Attenzione: Distruzione Totale", style = MaterialTheme.typography.titleMedium.copy(fontWeight = FontWeight.Bold), color = Color(0xFFDC2626))
                }
            },
            text = { Text("Sei sicuro di voler eliminare TUTTI i conti, i movimenti e i debiti?\nL'operazione à¨ irreversibile e cancellerà  i dati da tutti i tuoi dispositivi collegati.", style = MaterialTheme.typography.bodyMedium, color = Color(0xFFA0A0A0)) },
            confirmButton = {
                Button(
                    onClick = { onNukeAllData(); showNukePrompt = false; scope.launch { snackbarHostState.showSnackbar("Dati eliminati localmente. Verifica il cloud.", duration = SnackbarDuration.Long) } },
                    shape = RoundedCornerShape(14.dp),
                    colors = ButtonDefaults.buttonColors(containerColor = Color(0xFFDC2626), contentColor = Color.White)
                ) { Text("DISTRUGGI TUTTO", fontWeight = FontWeight.Bold) }
            },
            dismissButton = { TextButton(onClick = { showNukePrompt = false }) { Text("ANNULLA", color = Color.White, fontWeight = FontWeight.Bold) } }
        )
    }

    favoriteToRemove?.let { fav ->
        AlertDialog(
            onDismissRequest = { favoriteToRemove = null },
            shape = RoundedCornerShape(28.dp),
            containerColor = Color.White.copy(alpha = 0.12f),
            title = {
                Row(verticalAlignment = Alignment.CenterVertically) {
                    Icon(Icons.Outlined.Delete, contentDescription = null, tint = MaterialTheme.colorScheme.error, modifier = Modifier.size(24.dp))
                    Spacer(Modifier.width(8.dp))
                    Text("Rimuovi Rapido", style = MaterialTheme.typography.titleMedium.copy(fontWeight = FontWeight.Bold), color = MaterialTheme.colorScheme.error)
                }
            },
            text = { Text("Vuoi davvero rimuovere '${fav.description}' dai movimenti rapidi?", style = MaterialTheme.typography.bodyMedium, color = Color(0xFFA0A0A0)) },
            confirmButton = {
                Button(
                    onClick = { onRequestDeleteFavorite(fav); favoriteToRemove = null; if (favorites.size <= 1) isEditFavoritesMode = false },
                    shape = RoundedCornerShape(14.dp),
                    colors = ButtonDefaults.buttonColors(containerColor = MaterialTheme.colorScheme.error, contentColor = Color.White)
                ) { Text("RIMUOVI", fontWeight = FontWeight.Bold) }
            },
            dismissButton = { TextButton(onClick = { favoriteToRemove = null }) { Text("ANNULLA", color = Color.White, fontWeight = FontWeight.Bold) } }
        )
    }

    accountToDelete?.let { acc ->
        AlertDialog(
            onDismissRequest = { accountToDelete = null },
            shape = RoundedCornerShape(28.dp),
            containerColor = Color.White.copy(alpha = 0.12f),
            title = {
                Row(verticalAlignment = Alignment.CenterVertically) {
                    Icon(Icons.Outlined.DeleteForever, contentDescription = null, tint = MaterialTheme.colorScheme.error, modifier = Modifier.size(24.dp))
                    Spacer(Modifier.width(8.dp))
                    Text("Elimina Conto", style = MaterialTheme.typography.titleMedium.copy(fontWeight = FontWeight.Bold), color = MaterialTheme.colorScheme.error)
                }
            },
            text = { Text("Sei sicuro di voler eliminare il conto '${acc.name}' e tutto il suo storico?\nQuesta operazione non puà² essere annullata.", style = MaterialTheme.typography.bodyMedium, color = Color(0xFFA0A0A0)) },
            confirmButton = {
                Button(
                    onClick = { onRequestDelete(acc); accountToDelete = null; showAccountSelector = false },
                    shape = RoundedCornerShape(14.dp),
                    colors = ButtonDefaults.buttonColors(containerColor = MaterialTheme.colorScheme.error, contentColor = Color.White)
                ) { Text("ELIMINA", fontWeight = FontWeight.Bold) }
            },
            dismissButton = { TextButton(onClick = { accountToDelete = null }) { Text("ANNULLA", color = Color.White, fontWeight = FontWeight.Bold) } }
        )
    }

    accountToVault?.let { acc ->
        AlertDialog(
            onDismissRequest = { accountToVault = null },
            shape = RoundedCornerShape(28.dp),
            containerColor = Color.White.copy(alpha = 0.12f),
            title = {
                Row(verticalAlignment = Alignment.CenterVertically) {
                    Icon(Icons.Rounded.Lock, contentDescription = null, tint = Color(0xFFF59E0B), modifier = Modifier.size(24.dp))
                    Spacer(Modifier.width(8.dp))
                    Text("Sposta nel Vault", style = MaterialTheme.typography.titleMedium.copy(fontWeight = FontWeight.Bold), color = Color.White)
                }
            },
            text = { Text("Vuoi nascondere il conto '${acc.name}' nel Vault protetto?", style = MaterialTheme.typography.bodyMedium, color = Color(0xFFA0A0A0)) },
            confirmButton = {
                Button(
                    onClick = {
                        onUpdateAccount(acc.copy(isVisible = false))
                        accountToVault = null
                    },
                    shape = RoundedCornerShape(14.dp),
                    colors = ButtonDefaults.buttonColors(containerColor = Color(0xFFF59E0B), contentColor = Color.White)
                ) { Text("NASCONDI CONTO", fontWeight = FontWeight.Bold) }
            },
            dismissButton = { TextButton(onClick = { accountToVault = null }) { Text("ANNULLA", color = Color.White, fontWeight = FontWeight.Bold) } }
        )
    }

    accountToArchive?.let { acc ->
        AlertDialog(
            onDismissRequest = { accountToArchive = null },
            shape = RoundedCornerShape(28.dp),
            containerColor = Color.White.copy(alpha = 0.12f),
            title = {
                Row(verticalAlignment = Alignment.CenterVertically) {
                    Icon(Icons.Rounded.Archive, contentDescription = null, tint = Color(0xFF60A5FA), modifier = Modifier.size(24.dp))
                    Spacer(Modifier.width(8.dp))
                    Text("Archivia Conto", style = MaterialTheme.typography.titleMedium.copy(fontWeight = FontWeight.Bold), color = Color.White)
                }
            },
            text = { Text("Vuoi archiviare il conto '${acc.name}'?", style = MaterialTheme.typography.bodyMedium, color = Color(0xFFA0A0A0)) },
            confirmButton = {
                Button(
                    onClick = {
                        onUpdateAccount(acc.copy(isArchived = true))
                        accountToArchive = null
                    },
                    shape = RoundedCornerShape(14.dp),
                    colors = ButtonDefaults.buttonColors(containerColor = Color(0xFF60A5FA), contentColor = Color.White)
                ) { Text("ARCHIVIA", fontWeight = FontWeight.Bold) }
            },
            dismissButton = { TextButton(onClick = { accountToArchive = null }) { Text("ANNULLA", color = Color.White, fontWeight = FontWeight.Bold) } }
        )
    }

    accountToUnvault?.let { acc ->
        AlertDialog(
            onDismissRequest = { accountToUnvault = null },
            shape = RoundedCornerShape(28.dp),
            containerColor = Color.White.copy(alpha = 0.12f),
            title = {
                Row(verticalAlignment = Alignment.CenterVertically) {
                    Icon(Icons.Rounded.Visibility, contentDescription = null, tint = Color(0xFF60A5FA), modifier = Modifier.size(24.dp))
                    Spacer(Modifier.width(8.dp))
                    Text("Sblocca dal Vault", style = MaterialTheme.typography.titleMedium.copy(fontWeight = FontWeight.Bold), color = Color.White)
                }
            },
            text = { Text("Vuoi mostrare nuovamente il conto '${acc.name}' nella lista dei conti visibili?", style = MaterialTheme.typography.bodyMedium, color = Color(0xFFA0A0A0)) },
            confirmButton = {
                Button(
                    onClick = {
                        onUpdateAccount(acc.copy(isVisible = true, isHidden = false))
                        accountToUnvault = null
                    },
                    shape = RoundedCornerShape(14.dp),
                    colors = ButtonDefaults.buttonColors(containerColor = Color(0xFF60A5FA), contentColor = Color.White)
                ) { Text("MOSTRA CONTO", fontWeight = FontWeight.Bold) }
            },
            dismissButton = { TextButton(onClick = { accountToUnvault = null }) { Text("ANNULLA", color = Color.White, fontWeight = FontWeight.Bold) } }
        )
    }

    accountToUnarchive?.let { acc ->
        AlertDialog(
            onDismissRequest = { accountToUnarchive = null },
            shape = RoundedCornerShape(28.dp),
            containerColor = Color.White.copy(alpha = 0.12f),
            title = {
                Row(verticalAlignment = Alignment.CenterVertically) {
                    Icon(Icons.Rounded.Restore, contentDescription = null, tint = Color(0xFF10B981), modifier = Modifier.size(24.dp))
                    Spacer(Modifier.width(8.dp))
                    Text("Ripristina da Archivio", style = MaterialTheme.typography.titleMedium.copy(fontWeight = FontWeight.Bold), color = Color.White)
                }
            },
            text = { Text("Vuoi ripristinare il conto '${acc.name}' dall'archivio?", style = MaterialTheme.typography.bodyMedium, color = Color(0xFFA0A0A0)) },
            confirmButton = {
                Button(
                    onClick = {
                        onUpdateAccount(acc.copy(isArchived = false, isVisible = true))
                        accountToUnarchive = null
                    },
                    shape = RoundedCornerShape(14.dp),
                    colors = ButtonDefaults.buttonColors(containerColor = Color(0xFF10B981), contentColor = Color.White)
                ) { Text("RIPRISTINA", fontWeight = FontWeight.Bold) }
            },
            dismissButton = { TextButton(onClick = { accountToUnarchive = null }) { Text("ANNULLA", color = Color.White, fontWeight = FontWeight.Bold) } }
        )
    }

    recurringToPay?.let { rec ->
        var isProcessing by remember { mutableStateOf(false) }
        val isIncome = rec.type == "INCOME"

        AlertDialog(
            onDismissRequest = { if (!isProcessing) recurringToPay = null },
            shape = RoundedCornerShape(28.dp),
            containerColor = Color.White.copy(alpha = 0.12f),
            title = {
                Text(
                    text = if (isIncome) "Incassa Entrata Fissa" else "Paga Spesa Fissa",
                    style = MaterialTheme.typography.titleMedium.copy(fontWeight = FontWeight.Bold),
                    color = Color.White
                )
            },
            text = {
                Text(
                    text = if (isIncome)
                        "Vuoi registrare l'incasso di '${rec.name}' (${formatEuroFromCents(rec.amountCents)}) in anticipo?"
                    else
                        "Vuoi registrare il pagamento di '${rec.name}' (${formatEuroFromCents(rec.amountCents)}) in anticipo?",
                    style = MaterialTheme.typography.bodyMedium,
                    color = Color(0xFFA0A0A0)
                )
            },
            confirmButton = {
                Button(
                    onClick = {
                        if (!isProcessing) {
                            isProcessing = true
                            onPayRecurringEarly(rec)
                            recurringToPay = null
                            showRecurringExpenseSheet = false
                            showRecurringIncomeSheet = false
                        }
                    },
                    enabled = !isProcessing,
                    shape = RoundedCornerShape(14.dp),
                    colors = ButtonDefaults.buttonColors(
                        containerColor = if (isIncome) Color(0xFF10B981) else Color(0xFF60A5FA),
                        contentColor = Color.White
                    )
                ) {
                    Text(if (isIncome) "INCASSA ORA" else "PAGA ORA", fontWeight = FontWeight.Bold)
                }
            },
            dismissButton = {
                TextButton(
                    onClick = { recurringToPay = null },
                    enabled = !isProcessing
                ) { Text("ANNULLA", color = Color.White, fontWeight = FontWeight.Bold) }
            }
        )
    }

    recurringToUndo?.let { rec ->
        val isIncome = rec.type == "INCOME"

        AlertDialog(
            onDismissRequest = { recurringToUndo = null },
            shape = RoundedCornerShape(28.dp),
            containerColor = Color.White.copy(alpha = 0.12f),
            title = {
                Text(
                    text = if (isIncome) "Annulla Incasso" else "Annulla Pagamento",
                    style = MaterialTheme.typography.titleMedium.copy(fontWeight = FontWeight.Bold),
                    color = Color.White
                )
            },
            text = {
                Text(
                    text = if (isIncome)
                        "Vuoi annullare l'incasso già  registrato per '${rec.name}'?"
                    else
                        "Vuoi annullare il pagamento già  registrato per '${rec.name}'?",
                    style = MaterialTheme.typography.bodyMedium,
                    color = Color(0xFFA0A0A0)
                )
            },
            confirmButton = {
                Button(
                    onClick = {
                        onUndoRecurringPayment(rec)
                        recurringToUndo = null
                        showRecurringExpenseSheet = false
                        showRecurringIncomeSheet = false
                    },
                    shape = RoundedCornerShape(14.dp),
                    colors = ButtonDefaults.buttonColors(
                        containerColor = MaterialTheme.colorScheme.error,
                        contentColor = Color.White
                    )
                ) {
                    Text(
                        text = if (isIncome) "ANNULLA INCASSO" else "ANNULLA PAGAMENTO",
                        fontWeight = FontWeight.Bold
                    )
                }
            },
            dismissButton = {
                TextButton(onClick = { recurringToUndo = null }) {
                    Text("CHIUDI", color = Color.White, fontWeight = FontWeight.Bold)
                }
            }
        )
    }

    financingToPay?.let { fin ->
        val totalInstallment = fin.installmentAmountCents + (fin.commissionCents ?: 0L)
        AlertDialog(
            onDismissRequest = { financingToPay = null },
            shape = RoundedCornerShape(28.dp),
            containerColor = Color.White.copy(alpha = 0.12f),
            title = { Text("Paga Rata", style = MaterialTheme.typography.titleMedium.copy(fontWeight = FontWeight.Bold), color = Color.White) },
            text = { Text("Vuoi registrare il pagamento della rata di '${fin.name}' (${formatEuroFromCents(totalInstallment)}) in anticipo?", style = MaterialTheme.typography.bodyMedium, color = Color(0xFFA0A0A0)) },
            confirmButton = {
                Button(
                    onClick = { onPayFinancingEarly(fin); financingToPay = null; showFinancingSheet = false },
                    shape = RoundedCornerShape(14.dp),
                    colors = ButtonDefaults.buttonColors(containerColor = Color(0xFF60A5FA), contentColor = Color.White)
                ) {
                    Text("PAGA ORA", fontWeight = FontWeight.Bold)
                }
            },
            dismissButton = { TextButton(onClick = { financingToPay = null }) { Text("ANNULLA", color = Color.White, fontWeight = FontWeight.Bold) } }
        )
    }

    financingToUndo?.let { fin ->
        AlertDialog(
            onDismissRequest = { financingToUndo = null },
            shape = RoundedCornerShape(28.dp),
            containerColor = Color.White.copy(alpha = 0.12f),
            title = { Text("Annulla Pagamento", style = MaterialTheme.typography.titleMedium.copy(fontWeight = FontWeight.Bold), color = Color.White) },
            text = { Text("Vuoi annullare il pagamento dell'ultima rata registrata per '${fin.name}'?", style = MaterialTheme.typography.bodyMedium, color = Color(0xFFA0A0A0)) },
            confirmButton = {
                Button(
                    onClick = { onUndoFinancingPayment(fin); financingToUndo = null; showFinancingSheet = false },
                    shape = RoundedCornerShape(14.dp),
                    colors = ButtonDefaults.buttonColors(containerColor = MaterialTheme.colorScheme.error, contentColor = Color.White)
                ) {
                    Text("ANNULLA PAGAMENTO", fontWeight = FontWeight.Bold)
                }
            },
            dismissButton = { TextButton(onClick = { financingToUndo = null }) { Text("CHIUDI", color = Color.White, fontWeight = FontWeight.Bold) } }
        )
    }

    if (showSafetyBufferDialog) {
        var bufferInput by remember { mutableStateOf((safetyBufferCents / 100).toString()) }

        AlertDialog(
            onDismissRequest = { showSafetyBufferDialog = false },
            shape = RoundedCornerShape(28.dp),
            containerColor = Color.White.copy(alpha = 0.12f),
            title = { Text("Scorta di Sicurezza", style = MaterialTheme.typography.titleMedium.copy(fontWeight = FontWeight.Bold), color = Color.White) },
            text = {
                Column(verticalArrangement = Arrangement.spacedBy(12.dp)) {
                    Text("Imposta il tuo 'Nuovo Zero'. Riceverai un avviso se il saldo scende sotto questa soglia, ma la contabilità  della banca rimarrà  intatta.", style = MaterialTheme.typography.bodySmall, color = Color(0xFFA0A0A0))
                    OutlinedTextField(
                        value = bufferInput,
                        onValueChange = { if (it.all { c -> c.isDigit() }) bufferInput = it },
                        label = { Text("Importo da preservare (€)", color = Color(0xFFA0A0A0)) },
                        keyboardOptions = KeyboardOptions(keyboardType = KeyboardType.Number),
                        singleLine = true,
                        modifier = Modifier.fillMaxWidth(),
                        shape = RoundedCornerShape(12.dp),
                        colors = OutlinedTextFieldDefaults.colors(
                            focusedTextColor = Color.White,
                            unfocusedTextColor = Color.White,
                            focusedContainerColor = Color.Black.copy(alpha = 0.35f),
                            unfocusedContainerColor = Color.Black.copy(alpha = 0.25f),
                            focusedBorderColor = brandPrimary,
                            unfocusedBorderColor = Color.White.copy(alpha = 0.15f),
                            focusedLabelColor = brandPrimary,
                            unfocusedLabelColor = Color(0xFFA0A0A0)
                        )
                    )
                }
            },
            confirmButton = {
                Button(
                    onClick = {
                        val newBufferCents = (bufferInput.toLongOrNull() ?: 0L) * 100L
                        onUpdateSafetyBuffer(newBufferCents)
                        showSafetyBufferDialog = false
                    },
                    shape = RoundedCornerShape(14.dp),
                    colors = ButtonDefaults.buttonColors(containerColor = brandPrimary, contentColor = Color.White)
                ) { Text("SALVA", fontWeight = FontWeight.Bold) }
            },
            dismissButton = {
                TextButton(onClick = { showSafetyBufferDialog = false }) { Text("ANNULLA", color = Color(0xFFA0A0A0)) }
            }
        )
    }

            if (showAccantonatiPopup) {
                AlertDialog(
                    onDismissRequest = { showAccantonatiPopup = false },
                    shape = RoundedCornerShape(28.dp),
                    containerColor = Color.White.copy(alpha = 0.12f),
                    title = {
                        Row(verticalAlignment = Alignment.CenterVertically) {
                            Icon(Icons.Rounded.Lock, contentDescription = null, tint = Color(0xFFF59E0B), modifier = Modifier.size(24.dp))
                            Spacer(Modifier.width(8.dp))
                            Text("Dettaglio Accantonati", style = MaterialTheme.typography.titleMedium.copy(fontWeight = FontWeight.Bold), color = Color.White)
                        }
                    },
                    text = {
                        Column(modifier = Modifier.fillMaxWidth().verticalScroll(rememberScrollState()), verticalArrangement = Arrangement.spacedBy(8.dp)) {
                            if (totalSogni > 0L) {
                                Row(modifier = Modifier.fillMaxWidth().clip(RoundedCornerShape(6.dp)).clickable { showAccantonatiPopup = false; activeBreakdownType = "sogni" }.padding(vertical = 4.dp), horizontalArrangement = Arrangement.SpaceBetween, verticalAlignment = Alignment.CenterVertically) {
                                    Text("I Miei Sogni", style = MaterialTheme.typography.bodyMedium, color = Color(0xFFA0A0A0))
                                    Row(verticalAlignment = Alignment.CenterVertically) {
                                        ModernMoneyText(cents = totalSogni, hideBalances = hideBalances, color = Color.White, integerFontSize = 14.sp, decimalFontSize = 10.sp, symbolFontSize = 10.sp)
                                        Icon(Icons.Outlined.Info, null, modifier = Modifier.size(16.dp).padding(start = 4.dp), tint = Color.White.copy(alpha = 0.5f))
                                    }
                                }
                            }
                            if (totalPac > 0L) {
                                Row(modifier = Modifier.fillMaxWidth().clip(RoundedCornerShape(6.dp)).clickable { showAccantonatiPopup = false; activeBreakdownType = "pac" }.padding(vertical = 4.dp), horizontalArrangement = Arrangement.SpaceBetween, verticalAlignment = Alignment.CenterVertically) {
                                    Text("Smart PAC", style = MaterialTheme.typography.bodyMedium, color = Color(0xFF8B5CF6))
                                    Row(verticalAlignment = Alignment.CenterVertically) {
                                        ModernMoneyText(cents = totalPac, hideBalances = hideBalances, color = Color(0xFF8B5CF6), integerFontSize = 14.sp, decimalFontSize = 10.sp, symbolFontSize = 10.sp)
                                        Icon(Icons.Outlined.Info, null, modifier = Modifier.size(16.dp).padding(start = 4.dp), tint = Color(0xFF8B5CF6).copy(alpha = 0.5f))
                                    }
                                }
                            }
                            if (totalSalvadanai > 0L) {
                                Row(modifier = Modifier.fillMaxWidth().clip(RoundedCornerShape(6.dp)).clickable { showAccantonatiPopup = false; activeBreakdownType = "salvadanai" }.padding(vertical = 4.dp), horizontalArrangement = Arrangement.SpaceBetween, verticalAlignment = Alignment.CenterVertically) {
                                    Text("Salvadanai Virtuali", style = MaterialTheme.typography.bodyMedium, color = Color(0xFFA0A0A0))
                                    Row(verticalAlignment = Alignment.CenterVertically) {
                                        ModernMoneyText(cents = totalSalvadanai, hideBalances = hideBalances, color = Color.White, integerFontSize = 14.sp, decimalFontSize = 10.sp, symbolFontSize = 10.sp)
                                        Icon(Icons.Outlined.Info, null, modifier = Modifier.size(16.dp).padding(start = 4.dp), tint = Color.White.copy(alpha = 0.5f))
                                    }
                                }
                            }
                    if (unpaidFixed > 0L) {
                        Row(modifier = Modifier.fillMaxWidth().clip(RoundedCornerShape(6.dp)).clickable { showAccantonatiPopup = false; activeBreakdownType = "scadenze" }.padding(vertical = 4.dp), horizontalArrangement = Arrangement.SpaceBetween, verticalAlignment = Alignment.CenterVertically) {
                            Text("Scadenze Mese (Rate/Fisse)", style = MaterialTheme.typography.bodyMedium, color = Color(0xFFA0A0A0))
                            Row(verticalAlignment = Alignment.CenterVertically) {
                                ModernMoneyText(cents = unpaidFixed, hideBalances = hideBalances, color = Color.White, integerFontSize = 14.sp, decimalFontSize = 10.sp, symbolFontSize = 10.sp)
                                Icon(Icons.Outlined.Info, null, modifier = Modifier.size(16.dp).padding(start = 4.dp), tint = Color.White.copy(alpha = 0.5f))
                            }
                        }
                    }
                    if (movimentiInArrivoCents > 0L) {
                        Row(modifier = Modifier.fillMaxWidth().clip(RoundedCornerShape(6.dp)).clickable { showAccantonatiPopup = false; activeBreakdownType = "arrivo" }.padding(vertical = 4.dp), horizontalArrangement = Arrangement.SpaceBetween, verticalAlignment = Alignment.CenterVertically) {
                            Text("Movimenti in Arrivo (Già  generati)", style = MaterialTheme.typography.bodyMedium, color = Color(0xFFA0A0A0))
                            Row(verticalAlignment = Alignment.CenterVertically) {
                                ModernMoneyText(cents = movimentiInArrivoCents, hideBalances = hideBalances, color = Color.White, integerFontSize = 14.sp, decimalFontSize = 10.sp, symbolFontSize = 10.sp)
                                Icon(Icons.Outlined.Info, null, modifier = Modifier.size(16.dp).padding(start = 4.dp), tint = Color.White.copy(alpha = 0.5f))
                            }
                        }
                    }
                    if (totalCartelleMese > 0L) {
                        Row(modifier = Modifier.fillMaxWidth().clip(RoundedCornerShape(6.dp)).clickable { showAccantonatiPopup = false; activeBreakdownType = "cartelle" }.padding(vertical = 4.dp), horizontalArrangement = Arrangement.SpaceBetween, verticalAlignment = Alignment.CenterVertically) {
                            Text("Cartelle Esattoriali / Tasse", style = MaterialTheme.typography.bodyMedium, color = Color(0xFFA0A0A0))
                            Row(verticalAlignment = Alignment.CenterVertically) {
                                ModernMoneyText(cents = totalCartelleMese, hideBalances = hideBalances, color = Color.White, integerFontSize = 14.sp, decimalFontSize = 10.sp, symbolFontSize = 10.sp)
                                Icon(Icons.Outlined.Info, null, modifier = Modifier.size(16.dp).padding(start = 4.dp), tint = Color.White.copy(alpha = 0.5f))
                            }
                        }
                    }
                    if (cicliPositivi > 0L) {
                        Row(modifier = Modifier.fillMaxWidth().clip(RoundedCornerShape(6.dp)).clickable { showAccantonatiPopup = false; activeBreakdownType = "cicli" }.padding(vertical = 4.dp), horizontalArrangement = Arrangement.SpaceBetween, verticalAlignment = Alignment.CenterVertically) {
                            Text("Cicli Mensili", style = MaterialTheme.typography.bodyMedium, color = Color(0xFFA0A0A0))
                            Row(verticalAlignment = Alignment.CenterVertically) {
                                ModernMoneyText(cents = cicliPositivi, hideBalances = hideBalances, color = Color.White, integerFontSize = 14.sp, decimalFontSize = 10.sp, symbolFontSize = 10.sp)
                                Icon(Icons.Outlined.Info, null, modifier = Modifier.size(16.dp).padding(start = 4.dp), tint = Color.White.copy(alpha = 0.5f))
                            }
                        }
                    }
                    if (movimentiFantasmaCents > 0L) {
                        Row(modifier = Modifier.fillMaxWidth().clip(RoundedCornerShape(6.dp)).clickable { showAccantonatiPopup = false; activeBreakdownType = "programmati" }.padding(vertical = 4.dp), horizontalArrangement = Arrangement.SpaceBetween, verticalAlignment = Alignment.CenterVertically) {
                            Text("Movimenti Programmati", style = MaterialTheme.typography.bodyMedium, color = Color(0xFFA0A0A0))
                            Row(verticalAlignment = Alignment.CenterVertically) {
                                ModernMoneyText(cents = movimentiFantasmaCents, hideBalances = hideBalances, color = Color.White, integerFontSize = 14.sp, decimalFontSize = 10.sp, symbolFontSize = 10.sp)
                                Icon(Icons.Outlined.Info, null, modifier = Modifier.size(16.dp).padding(start = 4.dp), tint = Color.White.copy(alpha = 0.5f))
                            }
                        }
                    }

                    if (emergencyBalanceCents > 0L) {
                        Row(
                            modifier = Modifier
                                .fillMaxWidth()
                                .clip(RoundedCornerShape(6.dp))
                                .clickable { showAccantonatiPopup = false; showEmergencySheet = true }
                                .padding(vertical = 4.dp),
                            horizontalArrangement = Arrangement.SpaceBetween,
                            verticalAlignment = Alignment.CenterVertically
                        ) {
                            Text("Fondo di Emergenza (Scudo)", style = MaterialTheme.typography.bodyMedium, color = Color(0xFFA0A0A0))
                            Row(verticalAlignment = Alignment.CenterVertically) {
                                ModernMoneyText(cents = emergencyVisibile, hideBalances = hideBalances, color = Color(0xFF60A5FA), integerFontSize = 14.sp, decimalFontSize = 10.sp, symbolFontSize = 10.sp)
                                Icon(Icons.Outlined.Info, null, modifier = Modifier.size(16.dp).padding(start = 4.dp), tint = Color.White.copy(alpha = 0.5f))
                            }
                        }
                    }
                    HorizontalDivider(color = Color.White.copy(alpha = 0.15f))

                    Row(modifier = Modifier.fillMaxWidth().padding(top = 4.dp), horizontalArrangement = Arrangement.SpaceBetween, verticalAlignment = Alignment.Bottom) {
                        Text("TOTALE", style = MaterialTheme.typography.bodyMedium.copy(fontWeight = FontWeight.Bold), color = Color.White)
                        ModernMoneyText(cents = totalAccantonato, hideBalances = hideBalances, color = Color(0xFFF59E0B), integerFontSize = 18.sp, decimalFontSize = 12.sp, symbolFontSize = 12.sp)
                    }
                }
            },
            confirmButton = {
                Button(
                    onClick = { showAccantonatiPopup = false },
                    modifier = Modifier.fillMaxWidth(),
                    shape = RoundedCornerShape(14.dp),
                    colors = ButtonDefaults.buttonColors(containerColor = Color.White.copy(alpha = 0.12f), contentColor = Color.White)
                ) {
                    Text("CHIUDI", fontWeight = FontWeight.Bold, color = Color.White)
                }
            }
        )
    }



    // ðŸš€ POPUP COORDINATE BANCARIE COMPLETE PER SINGOLO CONTO (SUPPORTA CARTA E LIBRETTO)
    if (showIbanDialog && currentIbanAccount != null) {
        AccountDetailsDialog(
            account = currentIbanAccount,
            settings = settings,
            savedIban = savedIban,
            onDismiss = { showIbanDialog = false },
            onSave = { accId, detailsMap, finalIban ->
                scope.launch(kotlinx.coroutines.Dispatchers.Default) {
                    com.example.monetix.db.FirestoreHelper().salvaAccountBankDetails(accId, detailsMap)
                    com.example.monetix.db.FirestoreHelper().salvaAccountIban(accId, finalIban)
                }
                savedIban = finalIban
                showIbanDialog = false
            },
            onShare = { shareMessage ->
                clipboardManager.setText(androidx.compose.ui.text.AnnotatedString(shareMessage))
                shareText(shareMessage, "Coordinate · ${currentIbanAccount.name}")
                scope.launch {
                    snackbarHostState.showSnackbar("Coordinate copiate! Scegli l'app con cui condividere.", duration = androidx.compose.material3.SnackbarDuration.Short)
                }
            },
            triggerHaptic = { triggerHapticTick() }
        )
    }


}


// ==========================================
// ðŸš€ FUNZIONI DI SUPPORTO E CARDS
// ==========================================

@Composable
fun SegmentedProgressBar(paid: Long, programmed: Long, unpaid: Long) {
    val total = paid + programmed + unpaid
    Row(modifier = Modifier.fillMaxWidth().height(8.dp).clip(CircleShape)) {
        if (total <= 0L) {
            Box(modifier = Modifier.fillMaxSize().background(Color.White.copy(alpha = 0.1f)))
        } else {
            val pPaid = paid.toFloat() / total
            val pProg = programmed.toFloat() / total
            val pUnpaid = unpaid.toFloat() / total

            if (pPaid > 0f) {
                Box(modifier = Modifier.weight(pPaid).fillMaxHeight().background(Color(0xFF34D399)))
            }
            if (pProg > 0f) {
                Box(modifier = Modifier.weight(pProg).fillMaxHeight().background(Color(0xFFFBBF24)))
            }
            if (pUnpaid > 0f) {
                Box(modifier = Modifier.weight(pUnpaid).fillMaxHeight().background(Color(0xFFF87171)))
            }
        }
    }
}

// ðŸš€ NUOVO COMPONENTE: LEGENDA A DUE RIGHE
@Composable
fun StatusLegendItem(color: Color, label: String, amountText: String) {
    Column(horizontalAlignment = Alignment.Start) {
        Row(verticalAlignment = Alignment.CenterVertically) {
            Box(modifier = Modifier.size(8.dp).background(color, CircleShape))
            Spacer(modifier = Modifier.width(4.dp))
            Text(
                text = label,
                style = MaterialTheme.typography.labelSmall,
                color = Color.White.copy(alpha = 0.7f),
                fontSize = 10.sp,
                fontWeight = FontWeight.SemiBold
            )
        }
        Text(
            text = amountText,
            style = MaterialTheme.typography.labelSmall,
            color = Color.White,
            fontSize = 11.sp,
            fontWeight = FontWeight.Bold,
            modifier = Modifier.padding(start = 12.dp, top = 2.dp)
        )
    }
}

@Composable
fun SegmentedProgressCardContent(
    title: String,
    icon: androidx.compose.ui.graphics.vector.ImageVector,
    iconTint: Color,
    paidCents: Long,
    programmedCents: Long,
    unpaidCents: Long,
    totalCents: Long,
    hideBalances: Boolean,
    paidLabel: String = "Pagato",
    programmedLabel: String = "Programmato",
    unpaidLabel: String = "Da pagare",
    onClick: () -> Unit
) {
    Surface(
        modifier = Modifier.fillMaxWidth().clickable(onClick = onClick),
        color = Color.Transparent
    ) {
        Column(modifier = Modifier.fillMaxWidth().padding(vertical = 8.dp)) {
            Row(verticalAlignment = Alignment.CenterVertically) {
                Surface(
                    shape = CircleShape,
                    color = iconTint.copy(alpha = 0.15f),
                    modifier = Modifier.size(44.dp)
                ) {
                    Icon(icon, null, tint = iconTint, modifier = Modifier.padding(10.dp))
                }
                Spacer(Modifier.width(16.dp))
                Column(modifier = Modifier.weight(1f)) {
                    Row(modifier = Modifier.fillMaxWidth(), horizontalArrangement = Arrangement.SpaceBetween, verticalAlignment = Alignment.CenterVertically) {
                        Text(title, style = MaterialTheme.typography.titleMedium.copy(fontWeight = FontWeight.Black), color = Color.White)
                        if (totalCents > 0L) {
                            ModernMoneyText(
                                cents = totalCents,
                                hideBalances = hideBalances,
                                color = Color.White,
                                integerFontSize = 16.sp, decimalFontSize = 12.sp, symbolFontSize = 12.sp
                            )
                        }
                    }
                    Text("Tocca per i dettagli", style = MaterialTheme.typography.labelSmall, color = Color.White.copy(alpha = 0.6f))
                }
            }

            if (totalCents > 0L) {
                Spacer(Modifier.height(16.dp))
                SegmentedProgressBar(paid = paidCents, programmed = programmedCents, unpaid = unpaidCents)
                Spacer(Modifier.height(14.dp))

                if (hideBalances) {
                    Row(modifier = Modifier.fillMaxWidth(), horizontalArrangement = Arrangement.SpaceBetween) {
                        StatusLegendItem(Color(0xFF34D399), paidLabel, "â€¢â€¢â€¢")
                        StatusLegendItem(Color(0xFFFBBF24), programmedLabel, "â€¢â€¢â€¢")
                        StatusLegendItem(Color(0xFFF87171), unpaidLabel, "â€¢â€¢â€¢")
                    }
                } else {
                    Row(modifier = Modifier.fillMaxWidth(), horizontalArrangement = Arrangement.SpaceBetween) {
                        StatusLegendItem(Color(0xFF34D399), paidLabel, formatEuroFromCents(paidCents, false))
                        StatusLegendItem(Color(0xFFFBBF24), programmedLabel, formatEuroFromCents(programmedCents, false))
                        StatusLegendItem(Color(0xFFF87171), unpaidLabel, formatEuroFromCents(unpaidCents, false))
                    }
                }
            }
        }
    }
}

@OptIn(ExperimentalMaterial3Api::class)
@Composable
fun HomeBreakdownDialog(title: String, itemsList: List<Pair<String, Long>>, hideBalances: Boolean, onDismiss: () -> Unit) {
    AlertDialog(
        onDismissRequest = onDismiss,
        shape = RoundedCornerShape(28.dp),
        containerColor = Color.White.copy(alpha = 0.12f),
        title = { Text(title, fontWeight = FontWeight.Bold, color = Color.White) },
        text = {
            if (itemsList.isEmpty()) {
                Text("Nessun dato disponibile.", color = Color(0xFFA0A0A0))
            } else {
                LazyColumn(modifier = Modifier.fillMaxWidth().heightIn(max = 400.dp)) {
                    items(itemsList) { itemData ->
                        val name = itemData.first
                        val amount = itemData.second
                        Row(modifier = Modifier.fillMaxWidth().padding(vertical = 12.dp), horizontalArrangement = Arrangement.SpaceBetween, verticalAlignment = Alignment.CenterVertically) {
                            Text(name, modifier = Modifier.weight(1f).padding(end = 8.dp), maxLines = 1, overflow = TextOverflow.Ellipsis, style = MaterialTheme.typography.bodyMedium.copy(fontWeight = FontWeight.SemiBold), color = Color.White)
                            ModernMoneyText(cents = amount, hideBalances = hideBalances, color = Color.White, integerFontSize = 16.sp, decimalFontSize = 12.sp, symbolFontSize = 12.sp)
                        }
                        HorizontalDivider(color = Color.White.copy(alpha = 0.05f))
                    }
                }
            }
        },
        confirmButton = { TextButton(onClick = onDismiss) { Text("CHIUDI", fontWeight = FontWeight.Bold, color = Color.White) } }
    )
}